/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WeaveCopilotRouteImport } from './routes/weave-copilot'
import { Route as ParentRouteImport } from './routes/parent'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as OnboardRouteImport } from './routes/onboard'
import { Route as FormsRouteImport } from './routes/forms'
import { Route as BridgelineRouteImport } from './routes/bridgeline'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CallsIndexRouteImport } from './routes/calls/index'
import { Route as BulkIndexRouteImport } from './routes/bulk_/index'
import { Route as AnalyticsIndexRouteImport } from './routes/analytics/index'
import { Route as XParentRouteImport } from './routes/x_/parent'
import { Route as WeaveAdminRolesRouteImport } from './routes/weave-admin/roles'
import { Route as TestErrorRouteImport } from './routes/test_.error'
import { Route as TestIdRouteImport } from './routes/test.$id'
import { Route as ScheduleScheduleActivityRouteImport } from './routes/schedule/schedule-activity'
import { Route as ScheduleRequestHistoryRouteImport } from './routes/schedule/request-history'
import { Route as ScheduleQuickfillHistoryRouteImport } from './routes/schedule/quickfill-history'
import { Route as ScheduleEligibilityListRouteImport } from './routes/schedule/eligibility-list'
import { Route as ScheduleDebugRouteImport } from './routes/schedule/debug'
import { Route as ScheduleCalendarRouteImport } from './routes/schedule/calendar'
import { Route as ScheduleAvailabilityRouteImport } from './routes/schedule/availability'
import { Route as ReviewsSiteRouteImport } from './routes/reviews/$site'
import { Route as PaymentsRefundsRouteImport } from './routes/payments/refunds'
import { Route as PaymentsPayoutsRouteImport } from './routes/payments/payouts'
import { Route as PaymentsPaymentPlansRouteImport } from './routes/payments/payment-plans'
import { Route as PaymentsInvoicesRouteImport } from './routes/payments/invoices'
import { Route as OnboardingFormRouteImport } from './routes/onboarding/form'
import { Route as NrAuthTestIdRouteImport } from './routes/nr-auth-test.$id'
import { Route as MessagesFilterRouteImport } from './routes/messages/$filter'
import { Route as HomePartnersRouteImport } from './routes/home/partners'
import { Route as HomeOnboardingRouteImport } from './routes/home/onboarding'
import { Route as HomeDashboardRouteImport } from './routes/home/dashboard'
import { Route as FormsTemplatesRouteImport } from './routes/forms/templates'
import { Route as FormsSubmissionsRouteImport } from './routes/forms/submissions'
import { Route as FormsLibraryRouteImport } from './routes/forms/library'
import { Route as FormsKioskRouteImport } from './routes/forms/kiosk'
import { Route as FormsDigitizationRouteImport } from './routes/forms/digitization'
import { Route as FaxFilterRouteImport } from './routes/fax/$filter'
import { Route as ContactsListsRouteImport } from './routes/contacts/lists'
import { Route as ContactsFilterRouteImport } from './routes/contacts/$filter'
import { Route as CallsVoicemailsRouteImport } from './routes/calls/voicemails'
import { Route as CallsTeamPresenceRouteImport } from './routes/calls/team-presence'
import { Route as CallsCallQueueStatsRouteImport } from './routes/calls/call-queue-stats'
import { Route as CallsCallHistoryRouteImport } from './routes/calls/call-history'
import { Route as BulkSubNavRouteImport } from './routes/bulk_/$subNav'
import { Route as AnalyticsStaffPerformanceRouteImport } from './routes/analytics/staff-performance'
import { Route as AnalyticsRoiRouteImport } from './routes/analytics/roi'
import { Route as AnalyticsReviewsRouteImport } from './routes/analytics/reviews'
import { Route as AnalyticsPracticeRouteImport } from './routes/analytics/practice'
import { Route as AnalyticsPhoneRouteImport } from './routes/analytics/phone'
import { Route as AnalyticsMessagingRouteImport } from './routes/analytics/messaging'
import { Route as AnalyticsMarketingAttributionRouteImport } from './routes/analytics/marketing-attribution'
import { Route as AnalyticsDashboardRouteImport } from './routes/analytics/dashboard'
import { Route as AnalyticsCallIntelligenceRouteImport } from './routes/analytics/call-intelligence'
import { Route as AnalyticsAutoRecallRouteImport } from './routes/analytics/auto-recall'
import { Route as AnalyticsAppointmentRouteImport } from './routes/analytics/appointment'
import { Route as AnalyticsAiReceptionistRouteImport } from './routes/analytics/ai-receptionist'
import { Route as PublicSignInRouteImport } from './routes/_public/sign-in'
import { Route as PublicResetRouteImport } from './routes/_public/reset'
import { Route as PublicPasswordResetRouteImport } from './routes/_public/password-reset'
import { Route as PublicOnboardingDemoRouteImport } from './routes/_public/onboarding-demo'
import { Route as PublicOktaRedirectRouteImport } from './routes/_public/okta-redirect'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as PublicItPartnerQuotesRouteImport } from './routes/_public/it-partner-quotes'
import { Route as PublicHydraErrorRouteImport } from './routes/_public/hydra-error'
import { Route as PublicFrontChannelLogoutRouteImport } from './routes/_public/front-channel-logout'
import { Route as XRedirect2RouteImport } from './routes/x_/redirect_.2'
import { Route as XRedirect1RouteImport } from './routes/x_/redirect_.1'
import { Route as XParentChildRouteImport } from './routes/x_/parent.child'
import { Route as ReviewsSiteReviewIdRouteImport } from './routes/reviews/$site.$reviewId'
import { Route as PaymentsRefundsInvoiceIdRouteImport } from './routes/payments/refunds_.$invoiceId'
import { Route as PaymentsPayoutsPayoutIdRouteImport } from './routes/payments/payouts_.$payoutId'
import { Route as PaymentsPaymentPlansCreateRouteImport } from './routes/payments/payment-plans_.create'
import { Route as PaymentsPaymentPlansPlanIdRouteImport } from './routes/payments/payment-plans_.$planId'
import { Route as PaymentsInvoicesIdRouteImport } from './routes/payments/invoices_.$id'
import { Route as MessagesFilterNewRouteImport } from './routes/messages/$filter.new'
import { Route as FormsSubmissionsSentRouteImport } from './routes/forms/submissions.sent'
import { Route as FormsSubmissionsInboxRouteImport } from './routes/forms/submissions.inbox'
import { Route as FormsSubmissionsArchivedRouteImport } from './routes/forms/submissions.archived'
import { Route as FormsLibraryPacketsRouteImport } from './routes/forms/library.packets'
import { Route as FormsLibraryFormsRouteImport } from './routes/forms/library.forms'
import { Route as FormsKioskPatientKioskRouteImport } from './routes/forms/kiosk.patient-kiosk'
import { Route as FormsBuilderIdRouteImport } from './routes/forms/builder_.$id'
import { Route as FaxDraftsTemplateEditorRouteImport } from './routes/fax/drafts/template-editor'
import { Route as FaxDraftsNewFromTemplateRouteImport } from './routes/fax/drafts/new-from-template'
import { Route as FaxDraftsNewRouteImport } from './routes/fax/drafts/new'
import { Route as FaxDraftsDraftIdRouteImport } from './routes/fax/drafts/$draftId'
import { Route as FaxFilterFaxIdRouteImport } from './routes/fax/$filter.$faxId'
import { Route as BulkSubNavTypeRouteImport } from './routes/bulk_/$subNav_.$type'
import { Route as AnalyticsRoiNoShowRateRouteImport } from './routes/analytics/roi.no-show-rate'
import { Route as AnalyticsRoiMissedCallTextConversionRouteImport } from './routes/analytics/roi.missed-call-text-conversion'
import { Route as AnalyticsRoiBulkTextRouteImport } from './routes/analytics/roi.bulk-text'
import { Route as AnalyticsRoiAppointmentRemindersRouteImport } from './routes/analytics/roi.appointment-reminders'
import { Route as AnalyticsPracticeUnscheduledPatientsRouteImport } from './routes/analytics/practice.unscheduled-patients'
import { Route as AnalyticsPracticeRestorativeTreatmentRouteImport } from './routes/analytics/practice.restorative-treatment'
import { Route as AnalyticsPracticeRecapturedPatientsRouteImport } from './routes/analytics/practice.recaptured-patients'
import { Route as AnalyticsPracticePractitionerAnalysisRouteImport } from './routes/analytics/practice.practitioner-analysis'
import { Route as AnalyticsPracticeNewPatientsRouteImport } from './routes/analytics/practice.new-patients'
import { Route as AnalyticsPracticeMainRouteImport } from './routes/analytics/practice.main'
import { Route as AnalyticsPracticeHygieneTreatmentRouteImport } from './routes/analytics/practice.hygiene-treatment'
import { Route as AnalyticsPracticeHygieneFollowUpRouteImport } from './routes/analytics/practice.hygiene-follow-up'
import { Route as AnalyticsPracticeDemographicsRouteImport } from './routes/analytics/practice.demographics'
import { Route as AnalyticsPracticeCancelledAppointmentsRouteImport } from './routes/analytics/practice.cancelled-appointments'
import { Route as AnalyticsPhonePhoneTreeCallVolumeAllRouteImport } from './routes/analytics/phone.phone-tree-call-volume-all'
import { Route as AnalyticsPhoneMainRouteImport } from './routes/analytics/phone.main'
import { Route as AnalyticsPhoneCallVolumeRouteImport } from './routes/analytics/phone.call-volume'
import { Route as AnalyticsPhoneCallDurationRouteImport } from './routes/analytics/phone.call-duration'
import { Route as AnalyticsMarketingAttributionMainRouteImport } from './routes/analytics/marketing-attribution.main'
import { Route as AnalyticsCallIntelligenceMainRouteImport } from './routes/analytics/call-intelligence.main'
import { Route as AnalyticsCallIntelligenceIdRouteImport } from './routes/analytics/call-intelligence.$id'
import { Route as PublicSignInCallbackRouteImport } from './routes/_public/sign-in_.callback'
import { Route as PublicResetPasswordNonceTokenRouteImport } from './routes/_public/reset-password_/$nonceToken'
import { Route as PublicQuotesQuoteIdRouteImport } from './routes/_public/quotes_/$quoteId'
import { Route as PublicPortalLoginRouteImport } from './routes/_public/portal/login'
import { Route as PublicOnboardingDemoFormRouteImport } from './routes/_public/onboarding-demo/form'
import { Route as PublicNrPublicTestIdRouteImport } from './routes/_public/nr-public-test.$id'
import { Route as PaymentsPayoutsPayoutIdLocationIdRouteImport } from './routes/payments/payouts_.$payoutId_.$locationId'
import { Route as OnboardingFormLocationIdDashboardRouteImport } from './routes/onboarding/form.$locationId_.dashboard'
import { Route as OnboardingFormLocationIdCompleteRouteImport } from './routes/onboarding/form.$locationId_.complete'
import { Route as OnboardingFormLocationIdSectionRouteImport } from './routes/onboarding/form.$locationId_.$section'
import { Route as MessagesFilterGroupIdThreadIdRouteImport } from './routes/messages/$filter.$groupId_.$threadId'
import { Route as FormsSubmissionsSentSubmissionIdRouteImport } from './routes/forms/submissions.sent.$submissionId'
import { Route as FormsSubmissionsInboxSyncManuallyRouteImport } from './routes/forms/submissions.inbox.sync-manually'
import { Route as FormsSubmissionsInboxReviewedRouteImport } from './routes/forms/submissions.inbox.reviewed'
import { Route as FormsSubmissionsInboxRetrySyncRouteImport } from './routes/forms/submissions.inbox.retry-sync'
import { Route as FormsSubmissionsInboxNeedsReviewRouteImport } from './routes/forms/submissions.inbox.needs-review'
import { Route as FormsSubmissionsInboxCompletedRouteImport } from './routes/forms/submissions.inbox.completed'
import { Route as FormsSubmissionsInboxAllRouteImport } from './routes/forms/submissions.inbox.all'
import { Route as FormsSubmissionsArchivedSubmissionIdRouteImport } from './routes/forms/submissions.archived.$submissionId'
import { Route as FormsLibraryPacketsIdRouteImport } from './routes/forms/library.packets_.$id'
import { Route as FormsLibraryFormsIdRouteImport } from './routes/forms/library.forms_.$id'
import { Route as FaxDraftsDraftIdUploadRouteImport } from './routes/fax/drafts/$draftId.upload'
import { Route as FaxDraftsDraftIdFinalizeRouteImport } from './routes/fax/drafts/$draftId.finalize'
import { Route as FaxDraftsDraftIdCoverRouteImport } from './routes/fax/drafts/$draftId.cover'
import { Route as FaxDraftsDraftIdChooseTemplateRouteImport } from './routes/fax/drafts/$draftId.choose-template'
import { Route as FaxDraftsDraftIdBeginRouteImport } from './routes/fax/drafts/$draftId.begin'
import { Route as BulkSubNavTypeIdRouteImport } from './routes/bulk_/$subNav_.$type_.$id'
import { Route as AnalyticsMarketingAttributionCampaignNumberRouteImport } from './routes/analytics/marketing-attribution.campaign_.$number'
import { Route as AnalyticsCallIntelligenceServiceIssueTypeRouteImport } from './routes/analytics/call-intelligence.service-issue_.$type'
import { Route as AnalyticsCallIntelligenceFollowUpsTypeRouteImport } from './routes/analytics/call-intelligence.follow-ups_.$type'
import { Route as PublicTestRedirect2RouteImport } from './routes/_public/test_/redirect_.2'
import { Route as PublicTestRedirect1RouteImport } from './routes/_public/test_/redirect_.1'
import { Route as PublicQuotesQuoteIdPdfRouteImport } from './routes/_public/quotes_/$quoteId_.pdf'
import { Route as PublicPortingLoaLoaIdRouteImport } from './routes/_public/porting_/loa_.$loaId'
import { Route as PublicItPartnerQuotesQuoteIdPdfRouteImport } from './routes/_public/it-partner-quotes_/$quoteId_.pdf'
import { Route as FormsSubmissionsInboxSyncManuallySubmissionIdRouteImport } from './routes/forms/submissions.inbox.sync-manually.$submissionId'
import { Route as FormsSubmissionsInboxReviewedSubmissionIdRouteImport } from './routes/forms/submissions.inbox.reviewed.$submissionId'
import { Route as FormsSubmissionsInboxRetrySyncSubmissionIdRouteImport } from './routes/forms/submissions.inbox.retry-sync.$submissionId'
import { Route as FormsSubmissionsInboxNeedsReviewSubmissionIdRouteImport } from './routes/forms/submissions.inbox.needs-review.$submissionId'
import { Route as FormsSubmissionsInboxCompletedSubmissionIdRouteImport } from './routes/forms/submissions.inbox.completed.$submissionId'
import { Route as FormsSubmissionsInboxAllSubmissionIdRouteImport } from './routes/forms/submissions.inbox.all.$submissionId'
import { Route as CallsVoicemailBoxesMailboxIdMessagesMessageIdRouteImport } from './routes/calls/voicemail-boxes.$mailboxId.messages.$messageId'
import { Route as BulkSubNavTypeIdViewRouteImport } from './routes/bulk_/$subNav_.$type_.$id_.$view'
import { Route as PublicUserInviteNonceTokenLocationLocationIdRouteImport } from './routes/_public/user-invite_/$nonceToken_.location_.$locationId'
import { Route as PublicPortingLoaLoaIdPdfRouteImport } from './routes/_public/porting_/loa_.$loaId_.pdf'
import { Route as PublicOnboardingDemoFormLocationIdDashboardRouteImport } from './routes/_public/onboarding-demo/form.$locationId_.dashboard'
import { Route as PublicOnboardingDemoFormLocationIdCompleteRouteImport } from './routes/_public/onboarding-demo/form.$locationId_.complete'
import { Route as PublicOnboardingDemoFormLocationIdSectionRouteImport } from './routes/_public/onboarding-demo/form.$locationId_.$section'
import { Route as PublicAcceptInviteNonceTokenLocationLocationIdRouteImport } from './routes/_public/accept-invite_/$nonceToken_.location_.$locationId'
import { Route as OnboardingFormLocationIdSectionTaskStepRouteImport } from './routes/onboarding/form.$locationId_.$section_.$task_.$step'
import { Route as PublicPortalUserInviteNonceTokenLocationLocationIdRouteImport } from './routes/_public/portal/user-invite_.$nonceToken_.location_.$locationId'
import { Route as PublicPortalAcceptInviteNonceTokenLocationLocationIdRouteImport } from './routes/_public/portal/accept-invite_.$nonceToken_.location_.$locationId'
import { Route as PublicOnboardingDemoFormLocationIdSectionTaskStepRouteImport } from './routes/_public/onboarding-demo/form.$locationId_.$section_.$task_.$step'

const WeaveCopilotRoute = WeaveCopilotRouteImport.update({
  id: '/weave-copilot',
  path: '/weave-copilot',
  getParentRoute: () => rootRouteImport,
} as any)
const ParentRoute = ParentRouteImport.update({
  id: '/parent',
  path: '/parent',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardRoute = OnboardRouteImport.update({
  id: '/onboard',
  path: '/onboard',
  getParentRoute: () => rootRouteImport,
} as any)
const FormsRoute = FormsRouteImport.update({
  id: '/forms',
  path: '/forms',
  getParentRoute: () => rootRouteImport,
} as any)
const BridgelineRoute = BridgelineRouteImport.update({
  id: '/bridgeline',
  path: '/bridgeline',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CallsIndexRoute = CallsIndexRouteImport.update({
  id: '/calls/',
  path: '/calls/',
  getParentRoute: () => rootRouteImport,
} as any)
const BulkIndexRoute = BulkIndexRouteImport.update({
  id: '/bulk_/',
  path: '/bulk/',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsIndexRoute = AnalyticsIndexRouteImport.update({
  id: '/analytics/',
  path: '/analytics/',
  getParentRoute: () => rootRouteImport,
} as any)
const XParentRoute = XParentRouteImport.update({
  id: '/x_/parent',
  path: '/x/parent',
  getParentRoute: () => rootRouteImport,
} as any)
const WeaveAdminRolesRoute = WeaveAdminRolesRouteImport.update({
  id: '/weave-admin/roles',
  path: '/weave-admin/roles',
  getParentRoute: () => rootRouteImport,
} as any)
const TestErrorRoute = TestErrorRouteImport.update({
  id: '/test_/error',
  path: '/test/error',
  getParentRoute: () => rootRouteImport,
} as any)
const TestIdRoute = TestIdRouteImport.update({
  id: '/test/$id',
  path: '/test/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ScheduleScheduleActivityRoute =
  ScheduleScheduleActivityRouteImport.update({
    id: '/schedule/schedule-activity',
    path: '/schedule/schedule-activity',
    getParentRoute: () => rootRouteImport,
  } as any)
const ScheduleRequestHistoryRoute = ScheduleRequestHistoryRouteImport.update({
  id: '/schedule/request-history',
  path: '/schedule/request-history',
  getParentRoute: () => rootRouteImport,
} as any)
const ScheduleQuickfillHistoryRoute =
  ScheduleQuickfillHistoryRouteImport.update({
    id: '/schedule/quickfill-history',
    path: '/schedule/quickfill-history',
    getParentRoute: () => rootRouteImport,
  } as any)
const ScheduleEligibilityListRoute = ScheduleEligibilityListRouteImport.update({
  id: '/schedule/eligibility-list',
  path: '/schedule/eligibility-list',
  getParentRoute: () => rootRouteImport,
} as any)
const ScheduleDebugRoute = ScheduleDebugRouteImport.update({
  id: '/schedule/debug',
  path: '/schedule/debug',
  getParentRoute: () => rootRouteImport,
} as any)
const ScheduleCalendarRoute = ScheduleCalendarRouteImport.update({
  id: '/schedule/calendar',
  path: '/schedule/calendar',
  getParentRoute: () => rootRouteImport,
} as any)
const ScheduleAvailabilityRoute = ScheduleAvailabilityRouteImport.update({
  id: '/schedule/availability',
  path: '/schedule/availability',
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewsSiteRoute = ReviewsSiteRouteImport.update({
  id: '/reviews/$site',
  path: '/reviews/$site',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsRefundsRoute = PaymentsRefundsRouteImport.update({
  id: '/payments/refunds',
  path: '/payments/refunds',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsPayoutsRoute = PaymentsPayoutsRouteImport.update({
  id: '/payments/payouts',
  path: '/payments/payouts',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsPaymentPlansRoute = PaymentsPaymentPlansRouteImport.update({
  id: '/payments/payment-plans',
  path: '/payments/payment-plans',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsInvoicesRoute = PaymentsInvoicesRouteImport.update({
  id: '/payments/invoices',
  path: '/payments/invoices',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingFormRoute = OnboardingFormRouteImport.update({
  id: '/form',
  path: '/form',
  getParentRoute: () => OnboardingRoute,
} as any)
const NrAuthTestIdRoute = NrAuthTestIdRouteImport.update({
  id: '/nr-auth-test/$id',
  path: '/nr-auth-test/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const MessagesFilterRoute = MessagesFilterRouteImport.update({
  id: '/messages/$filter',
  path: '/messages/$filter',
  getParentRoute: () => rootRouteImport,
} as any)
const HomePartnersRoute = HomePartnersRouteImport.update({
  id: '/home/partners',
  path: '/home/partners',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeOnboardingRoute = HomeOnboardingRouteImport.update({
  id: '/home/onboarding',
  path: '/home/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeDashboardRoute = HomeDashboardRouteImport.update({
  id: '/home/dashboard',
  path: '/home/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const FormsTemplatesRoute = FormsTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => FormsRoute,
} as any)
const FormsSubmissionsRoute = FormsSubmissionsRouteImport.update({
  id: '/submissions',
  path: '/submissions',
  getParentRoute: () => FormsRoute,
} as any)
const FormsLibraryRoute = FormsLibraryRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => FormsRoute,
} as any)
const FormsKioskRoute = FormsKioskRouteImport.update({
  id: '/kiosk',
  path: '/kiosk',
  getParentRoute: () => FormsRoute,
} as any)
const FormsDigitizationRoute = FormsDigitizationRouteImport.update({
  id: '/digitization',
  path: '/digitization',
  getParentRoute: () => FormsRoute,
} as any)
const FaxFilterRoute = FaxFilterRouteImport.update({
  id: '/fax/$filter',
  path: '/fax/$filter',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactsListsRoute = ContactsListsRouteImport.update({
  id: '/contacts/lists',
  path: '/contacts/lists',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactsFilterRoute = ContactsFilterRouteImport.update({
  id: '/contacts/$filter',
  path: '/contacts/$filter',
  getParentRoute: () => rootRouteImport,
} as any)
const CallsVoicemailsRoute = CallsVoicemailsRouteImport.update({
  id: '/calls/voicemails',
  path: '/calls/voicemails',
  getParentRoute: () => rootRouteImport,
} as any)
const CallsTeamPresenceRoute = CallsTeamPresenceRouteImport.update({
  id: '/calls/team-presence',
  path: '/calls/team-presence',
  getParentRoute: () => rootRouteImport,
} as any)
const CallsCallQueueStatsRoute = CallsCallQueueStatsRouteImport.update({
  id: '/calls/call-queue-stats',
  path: '/calls/call-queue-stats',
  getParentRoute: () => rootRouteImport,
} as any)
const CallsCallHistoryRoute = CallsCallHistoryRouteImport.update({
  id: '/calls/call-history',
  path: '/calls/call-history',
  getParentRoute: () => rootRouteImport,
} as any)
const BulkSubNavRoute = BulkSubNavRouteImport.update({
  id: '/bulk_/$subNav',
  path: '/bulk/$subNav',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsStaffPerformanceRoute =
  AnalyticsStaffPerformanceRouteImport.update({
    id: '/analytics/staff-performance',
    path: '/analytics/staff-performance',
    getParentRoute: () => rootRouteImport,
  } as any)
const AnalyticsRoiRoute = AnalyticsRoiRouteImport.update({
  id: '/analytics/roi',
  path: '/analytics/roi',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsReviewsRoute = AnalyticsReviewsRouteImport.update({
  id: '/analytics/reviews',
  path: '/analytics/reviews',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsPracticeRoute = AnalyticsPracticeRouteImport.update({
  id: '/analytics/practice',
  path: '/analytics/practice',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsPhoneRoute = AnalyticsPhoneRouteImport.update({
  id: '/analytics/phone',
  path: '/analytics/phone',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsMessagingRoute = AnalyticsMessagingRouteImport.update({
  id: '/analytics/messaging',
  path: '/analytics/messaging',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsMarketingAttributionRoute =
  AnalyticsMarketingAttributionRouteImport.update({
    id: '/analytics/marketing-attribution',
    path: '/analytics/marketing-attribution',
    getParentRoute: () => rootRouteImport,
  } as any)
const AnalyticsDashboardRoute = AnalyticsDashboardRouteImport.update({
  id: '/analytics/dashboard',
  path: '/analytics/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsCallIntelligenceRoute =
  AnalyticsCallIntelligenceRouteImport.update({
    id: '/analytics/call-intelligence',
    path: '/analytics/call-intelligence',
    getParentRoute: () => rootRouteImport,
  } as any)
const AnalyticsAutoRecallRoute = AnalyticsAutoRecallRouteImport.update({
  id: '/analytics/auto-recall',
  path: '/analytics/auto-recall',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsAppointmentRoute = AnalyticsAppointmentRouteImport.update({
  id: '/analytics/appointment',
  path: '/analytics/appointment',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsAiReceptionistRoute = AnalyticsAiReceptionistRouteImport.update({
  id: '/analytics/ai-receptionist',
  path: '/analytics/ai-receptionist',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicSignInRoute = PublicSignInRouteImport.update({
  id: '/_public/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicResetRoute = PublicResetRouteImport.update({
  id: '/_public/reset',
  path: '/reset',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicPasswordResetRoute = PublicPasswordResetRouteImport.update({
  id: '/_public/password-reset',
  path: '/password-reset',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicOnboardingDemoRoute = PublicOnboardingDemoRouteImport.update({
  id: '/_public/onboarding-demo',
  path: '/onboarding-demo',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicOktaRedirectRoute = PublicOktaRedirectRouteImport.update({
  id: '/_public/okta-redirect',
  path: '/okta-redirect',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/_public/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicItPartnerQuotesRoute = PublicItPartnerQuotesRouteImport.update({
  id: '/_public/it-partner-quotes',
  path: '/it-partner-quotes',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicHydraErrorRoute = PublicHydraErrorRouteImport.update({
  id: '/_public/hydra-error',
  path: '/hydra-error',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicFrontChannelLogoutRoute =
  PublicFrontChannelLogoutRouteImport.update({
    id: '/_public/front-channel-logout',
    path: '/front-channel-logout',
    getParentRoute: () => rootRouteImport,
  } as any)
const XRedirect2Route = XRedirect2RouteImport.update({
  id: '/x_/redirect_/2',
  path: '/x/redirect/2',
  getParentRoute: () => rootRouteImport,
} as any)
const XRedirect1Route = XRedirect1RouteImport.update({
  id: '/x_/redirect_/1',
  path: '/x/redirect/1',
  getParentRoute: () => rootRouteImport,
} as any)
const XParentChildRoute = XParentChildRouteImport.update({
  id: '/child',
  path: '/child',
  getParentRoute: () => XParentRoute,
} as any)
const ReviewsSiteReviewIdRoute = ReviewsSiteReviewIdRouteImport.update({
  id: '/$reviewId',
  path: '/$reviewId',
  getParentRoute: () => ReviewsSiteRoute,
} as any)
const PaymentsRefundsInvoiceIdRoute =
  PaymentsRefundsInvoiceIdRouteImport.update({
    id: '/payments/refunds_/$invoiceId',
    path: '/payments/refunds/$invoiceId',
    getParentRoute: () => rootRouteImport,
  } as any)
const PaymentsPayoutsPayoutIdRoute = PaymentsPayoutsPayoutIdRouteImport.update({
  id: '/payments/payouts_/$payoutId',
  path: '/payments/payouts/$payoutId',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsPaymentPlansCreateRoute =
  PaymentsPaymentPlansCreateRouteImport.update({
    id: '/payments/payment-plans_/create',
    path: '/payments/payment-plans/create',
    getParentRoute: () => rootRouteImport,
  } as any)
const PaymentsPaymentPlansPlanIdRoute =
  PaymentsPaymentPlansPlanIdRouteImport.update({
    id: '/payments/payment-plans_/$planId',
    path: '/payments/payment-plans/$planId',
    getParentRoute: () => rootRouteImport,
  } as any)
const PaymentsInvoicesIdRoute = PaymentsInvoicesIdRouteImport.update({
  id: '/payments/invoices_/$id',
  path: '/payments/invoices/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const MessagesFilterNewRoute = MessagesFilterNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => MessagesFilterRoute,
} as any)
const FormsSubmissionsSentRoute = FormsSubmissionsSentRouteImport.update({
  id: '/sent',
  path: '/sent',
  getParentRoute: () => FormsSubmissionsRoute,
} as any)
const FormsSubmissionsInboxRoute = FormsSubmissionsInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => FormsSubmissionsRoute,
} as any)
const FormsSubmissionsArchivedRoute =
  FormsSubmissionsArchivedRouteImport.update({
    id: '/archived',
    path: '/archived',
    getParentRoute: () => FormsSubmissionsRoute,
  } as any)
const FormsLibraryPacketsRoute = FormsLibraryPacketsRouteImport.update({
  id: '/packets',
  path: '/packets',
  getParentRoute: () => FormsLibraryRoute,
} as any)
const FormsLibraryFormsRoute = FormsLibraryFormsRouteImport.update({
  id: '/forms',
  path: '/forms',
  getParentRoute: () => FormsLibraryRoute,
} as any)
const FormsKioskPatientKioskRoute = FormsKioskPatientKioskRouteImport.update({
  id: '/patient-kiosk',
  path: '/patient-kiosk',
  getParentRoute: () => FormsKioskRoute,
} as any)
const FormsBuilderIdRoute = FormsBuilderIdRouteImport.update({
  id: '/builder_/$id',
  path: '/builder/$id',
  getParentRoute: () => FormsRoute,
} as any)
const FaxDraftsTemplateEditorRoute = FaxDraftsTemplateEditorRouteImport.update({
  id: '/fax/drafts/template-editor',
  path: '/fax/drafts/template-editor',
  getParentRoute: () => rootRouteImport,
} as any)
const FaxDraftsNewFromTemplateRoute =
  FaxDraftsNewFromTemplateRouteImport.update({
    id: '/fax/drafts/new-from-template',
    path: '/fax/drafts/new-from-template',
    getParentRoute: () => rootRouteImport,
  } as any)
const FaxDraftsNewRoute = FaxDraftsNewRouteImport.update({
  id: '/fax/drafts/new',
  path: '/fax/drafts/new',
  getParentRoute: () => rootRouteImport,
} as any)
const FaxDraftsDraftIdRoute = FaxDraftsDraftIdRouteImport.update({
  id: '/fax/drafts/$draftId',
  path: '/fax/drafts/$draftId',
  getParentRoute: () => rootRouteImport,
} as any)
const FaxFilterFaxIdRoute = FaxFilterFaxIdRouteImport.update({
  id: '/$faxId',
  path: '/$faxId',
  getParentRoute: () => FaxFilterRoute,
} as any)
const BulkSubNavTypeRoute = BulkSubNavTypeRouteImport.update({
  id: '/bulk_/$subNav_/$type',
  path: '/bulk/$subNav/$type',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsRoiNoShowRateRoute = AnalyticsRoiNoShowRateRouteImport.update({
  id: '/no-show-rate',
  path: '/no-show-rate',
  getParentRoute: () => AnalyticsRoiRoute,
} as any)
const AnalyticsRoiMissedCallTextConversionRoute =
  AnalyticsRoiMissedCallTextConversionRouteImport.update({
    id: '/missed-call-text-conversion',
    path: '/missed-call-text-conversion',
    getParentRoute: () => AnalyticsRoiRoute,
  } as any)
const AnalyticsRoiBulkTextRoute = AnalyticsRoiBulkTextRouteImport.update({
  id: '/bulk-text',
  path: '/bulk-text',
  getParentRoute: () => AnalyticsRoiRoute,
} as any)
const AnalyticsRoiAppointmentRemindersRoute =
  AnalyticsRoiAppointmentRemindersRouteImport.update({
    id: '/appointment-reminders',
    path: '/appointment-reminders',
    getParentRoute: () => AnalyticsRoiRoute,
  } as any)
const AnalyticsPracticeUnscheduledPatientsRoute =
  AnalyticsPracticeUnscheduledPatientsRouteImport.update({
    id: '/unscheduled-patients',
    path: '/unscheduled-patients',
    getParentRoute: () => AnalyticsPracticeRoute,
  } as any)
const AnalyticsPracticeRestorativeTreatmentRoute =
  AnalyticsPracticeRestorativeTreatmentRouteImport.update({
    id: '/restorative-treatment',
    path: '/restorative-treatment',
    getParentRoute: () => AnalyticsPracticeRoute,
  } as any)
const AnalyticsPracticeRecapturedPatientsRoute =
  AnalyticsPracticeRecapturedPatientsRouteImport.update({
    id: '/recaptured-patients',
    path: '/recaptured-patients',
    getParentRoute: () => AnalyticsPracticeRoute,
  } as any)
const AnalyticsPracticePractitionerAnalysisRoute =
  AnalyticsPracticePractitionerAnalysisRouteImport.update({
    id: '/practitioner-analysis',
    path: '/practitioner-analysis',
    getParentRoute: () => AnalyticsPracticeRoute,
  } as any)
const AnalyticsPracticeNewPatientsRoute =
  AnalyticsPracticeNewPatientsRouteImport.update({
    id: '/new-patients',
    path: '/new-patients',
    getParentRoute: () => AnalyticsPracticeRoute,
  } as any)
const AnalyticsPracticeMainRoute = AnalyticsPracticeMainRouteImport.update({
  id: '/main',
  path: '/main',
  getParentRoute: () => AnalyticsPracticeRoute,
} as any)
const AnalyticsPracticeHygieneTreatmentRoute =
  AnalyticsPracticeHygieneTreatmentRouteImport.update({
    id: '/hygiene-treatment',
    path: '/hygiene-treatment',
    getParentRoute: () => AnalyticsPracticeRoute,
  } as any)
const AnalyticsPracticeHygieneFollowUpRoute =
  AnalyticsPracticeHygieneFollowUpRouteImport.update({
    id: '/hygiene-follow-up',
    path: '/hygiene-follow-up',
    getParentRoute: () => AnalyticsPracticeRoute,
  } as any)
const AnalyticsPracticeDemographicsRoute =
  AnalyticsPracticeDemographicsRouteImport.update({
    id: '/demographics',
    path: '/demographics',
    getParentRoute: () => AnalyticsPracticeRoute,
  } as any)
const AnalyticsPracticeCancelledAppointmentsRoute =
  AnalyticsPracticeCancelledAppointmentsRouteImport.update({
    id: '/cancelled-appointments',
    path: '/cancelled-appointments',
    getParentRoute: () => AnalyticsPracticeRoute,
  } as any)
const AnalyticsPhonePhoneTreeCallVolumeAllRoute =
  AnalyticsPhonePhoneTreeCallVolumeAllRouteImport.update({
    id: '/phone-tree-call-volume-all',
    path: '/phone-tree-call-volume-all',
    getParentRoute: () => AnalyticsPhoneRoute,
  } as any)
const AnalyticsPhoneMainRoute = AnalyticsPhoneMainRouteImport.update({
  id: '/main',
  path: '/main',
  getParentRoute: () => AnalyticsPhoneRoute,
} as any)
const AnalyticsPhoneCallVolumeRoute =
  AnalyticsPhoneCallVolumeRouteImport.update({
    id: '/call-volume',
    path: '/call-volume',
    getParentRoute: () => AnalyticsPhoneRoute,
  } as any)
const AnalyticsPhoneCallDurationRoute =
  AnalyticsPhoneCallDurationRouteImport.update({
    id: '/call-duration',
    path: '/call-duration',
    getParentRoute: () => AnalyticsPhoneRoute,
  } as any)
const AnalyticsMarketingAttributionMainRoute =
  AnalyticsMarketingAttributionMainRouteImport.update({
    id: '/main',
    path: '/main',
    getParentRoute: () => AnalyticsMarketingAttributionRoute,
  } as any)
const AnalyticsCallIntelligenceMainRoute =
  AnalyticsCallIntelligenceMainRouteImport.update({
    id: '/main',
    path: '/main',
    getParentRoute: () => AnalyticsCallIntelligenceRoute,
  } as any)
const AnalyticsCallIntelligenceIdRoute =
  AnalyticsCallIntelligenceIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AnalyticsCallIntelligenceRoute,
  } as any)
const PublicSignInCallbackRoute = PublicSignInCallbackRouteImport.update({
  id: '/_public/sign-in_/callback',
  path: '/sign-in/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicResetPasswordNonceTokenRoute =
  PublicResetPasswordNonceTokenRouteImport.update({
    id: '/_public/reset-password_/$nonceToken',
    path: '/reset-password/$nonceToken',
    getParentRoute: () => rootRouteImport,
  } as any)
const PublicQuotesQuoteIdRoute = PublicQuotesQuoteIdRouteImport.update({
  id: '/_public/quotes_/$quoteId',
  path: '/quotes/$quoteId',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicPortalLoginRoute = PublicPortalLoginRouteImport.update({
  id: '/_public/portal/login',
  path: '/portal/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicOnboardingDemoFormRoute =
  PublicOnboardingDemoFormRouteImport.update({
    id: '/form',
    path: '/form',
    getParentRoute: () => PublicOnboardingDemoRoute,
  } as any)
const PublicNrPublicTestIdRoute = PublicNrPublicTestIdRouteImport.update({
  id: '/_public/nr-public-test/$id',
  path: '/nr-public-test/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsPayoutsPayoutIdLocationIdRoute =
  PaymentsPayoutsPayoutIdLocationIdRouteImport.update({
    id: '/payments/payouts_/$payoutId_/$locationId',
    path: '/payments/payouts/$payoutId/$locationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const OnboardingFormLocationIdDashboardRoute =
  OnboardingFormLocationIdDashboardRouteImport.update({
    id: '/$locationId_/dashboard',
    path: '/$locationId/dashboard',
    getParentRoute: () => OnboardingFormRoute,
  } as any)
const OnboardingFormLocationIdCompleteRoute =
  OnboardingFormLocationIdCompleteRouteImport.update({
    id: '/$locationId_/complete',
    path: '/$locationId/complete',
    getParentRoute: () => OnboardingFormRoute,
  } as any)
const OnboardingFormLocationIdSectionRoute =
  OnboardingFormLocationIdSectionRouteImport.update({
    id: '/$locationId_/$section',
    path: '/$locationId/$section',
    getParentRoute: () => OnboardingFormRoute,
  } as any)
const MessagesFilterGroupIdThreadIdRoute =
  MessagesFilterGroupIdThreadIdRouteImport.update({
    id: '/$groupId_/$threadId',
    path: '/$groupId/$threadId',
    getParentRoute: () => MessagesFilterRoute,
  } as any)
const FormsSubmissionsSentSubmissionIdRoute =
  FormsSubmissionsSentSubmissionIdRouteImport.update({
    id: '/$submissionId',
    path: '/$submissionId',
    getParentRoute: () => FormsSubmissionsSentRoute,
  } as any)
const FormsSubmissionsInboxSyncManuallyRoute =
  FormsSubmissionsInboxSyncManuallyRouteImport.update({
    id: '/sync-manually',
    path: '/sync-manually',
    getParentRoute: () => FormsSubmissionsInboxRoute,
  } as any)
const FormsSubmissionsInboxReviewedRoute =
  FormsSubmissionsInboxReviewedRouteImport.update({
    id: '/reviewed',
    path: '/reviewed',
    getParentRoute: () => FormsSubmissionsInboxRoute,
  } as any)
const FormsSubmissionsInboxRetrySyncRoute =
  FormsSubmissionsInboxRetrySyncRouteImport.update({
    id: '/retry-sync',
    path: '/retry-sync',
    getParentRoute: () => FormsSubmissionsInboxRoute,
  } as any)
const FormsSubmissionsInboxNeedsReviewRoute =
  FormsSubmissionsInboxNeedsReviewRouteImport.update({
    id: '/needs-review',
    path: '/needs-review',
    getParentRoute: () => FormsSubmissionsInboxRoute,
  } as any)
const FormsSubmissionsInboxCompletedRoute =
  FormsSubmissionsInboxCompletedRouteImport.update({
    id: '/completed',
    path: '/completed',
    getParentRoute: () => FormsSubmissionsInboxRoute,
  } as any)
const FormsSubmissionsInboxAllRoute =
  FormsSubmissionsInboxAllRouteImport.update({
    id: '/all',
    path: '/all',
    getParentRoute: () => FormsSubmissionsInboxRoute,
  } as any)
const FormsSubmissionsArchivedSubmissionIdRoute =
  FormsSubmissionsArchivedSubmissionIdRouteImport.update({
    id: '/$submissionId',
    path: '/$submissionId',
    getParentRoute: () => FormsSubmissionsArchivedRoute,
  } as any)
const FormsLibraryPacketsIdRoute = FormsLibraryPacketsIdRouteImport.update({
  id: '/packets_/$id',
  path: '/packets/$id',
  getParentRoute: () => FormsLibraryRoute,
} as any)
const FormsLibraryFormsIdRoute = FormsLibraryFormsIdRouteImport.update({
  id: '/forms_/$id',
  path: '/forms/$id',
  getParentRoute: () => FormsLibraryRoute,
} as any)
const FaxDraftsDraftIdUploadRoute = FaxDraftsDraftIdUploadRouteImport.update({
  id: '/upload',
  path: '/upload',
  getParentRoute: () => FaxDraftsDraftIdRoute,
} as any)
const FaxDraftsDraftIdFinalizeRoute =
  FaxDraftsDraftIdFinalizeRouteImport.update({
    id: '/finalize',
    path: '/finalize',
    getParentRoute: () => FaxDraftsDraftIdRoute,
  } as any)
const FaxDraftsDraftIdCoverRoute = FaxDraftsDraftIdCoverRouteImport.update({
  id: '/cover',
  path: '/cover',
  getParentRoute: () => FaxDraftsDraftIdRoute,
} as any)
const FaxDraftsDraftIdChooseTemplateRoute =
  FaxDraftsDraftIdChooseTemplateRouteImport.update({
    id: '/choose-template',
    path: '/choose-template',
    getParentRoute: () => FaxDraftsDraftIdRoute,
  } as any)
const FaxDraftsDraftIdBeginRoute = FaxDraftsDraftIdBeginRouteImport.update({
  id: '/begin',
  path: '/begin',
  getParentRoute: () => FaxDraftsDraftIdRoute,
} as any)
const BulkSubNavTypeIdRoute = BulkSubNavTypeIdRouteImport.update({
  id: '/bulk_/$subNav_/$type_/$id',
  path: '/bulk/$subNav/$type/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsMarketingAttributionCampaignNumberRoute =
  AnalyticsMarketingAttributionCampaignNumberRouteImport.update({
    id: '/campaign_/$number',
    path: '/campaign/$number',
    getParentRoute: () => AnalyticsMarketingAttributionRoute,
  } as any)
const AnalyticsCallIntelligenceServiceIssueTypeRoute =
  AnalyticsCallIntelligenceServiceIssueTypeRouteImport.update({
    id: '/service-issue_/$type',
    path: '/service-issue/$type',
    getParentRoute: () => AnalyticsCallIntelligenceRoute,
  } as any)
const AnalyticsCallIntelligenceFollowUpsTypeRoute =
  AnalyticsCallIntelligenceFollowUpsTypeRouteImport.update({
    id: '/follow-ups_/$type',
    path: '/follow-ups/$type',
    getParentRoute: () => AnalyticsCallIntelligenceRoute,
  } as any)
const PublicTestRedirect2Route = PublicTestRedirect2RouteImport.update({
  id: '/_public/test_/redirect_/2',
  path: '/test/redirect/2',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicTestRedirect1Route = PublicTestRedirect1RouteImport.update({
  id: '/_public/test_/redirect_/1',
  path: '/test/redirect/1',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicQuotesQuoteIdPdfRoute = PublicQuotesQuoteIdPdfRouteImport.update({
  id: '/_public/quotes_/$quoteId_/pdf',
  path: '/quotes/$quoteId/pdf',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicPortingLoaLoaIdRoute = PublicPortingLoaLoaIdRouteImport.update({
  id: '/_public/porting_/loa_/$loaId',
  path: '/porting/loa/$loaId',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicItPartnerQuotesQuoteIdPdfRoute =
  PublicItPartnerQuotesQuoteIdPdfRouteImport.update({
    id: '/_public/it-partner-quotes_/$quoteId_/pdf',
    path: '/it-partner-quotes/$quoteId/pdf',
    getParentRoute: () => rootRouteImport,
  } as any)
const FormsSubmissionsInboxSyncManuallySubmissionIdRoute =
  FormsSubmissionsInboxSyncManuallySubmissionIdRouteImport.update({
    id: '/$submissionId',
    path: '/$submissionId',
    getParentRoute: () => FormsSubmissionsInboxSyncManuallyRoute,
  } as any)
const FormsSubmissionsInboxReviewedSubmissionIdRoute =
  FormsSubmissionsInboxReviewedSubmissionIdRouteImport.update({
    id: '/$submissionId',
    path: '/$submissionId',
    getParentRoute: () => FormsSubmissionsInboxReviewedRoute,
  } as any)
const FormsSubmissionsInboxRetrySyncSubmissionIdRoute =
  FormsSubmissionsInboxRetrySyncSubmissionIdRouteImport.update({
    id: '/$submissionId',
    path: '/$submissionId',
    getParentRoute: () => FormsSubmissionsInboxRetrySyncRoute,
  } as any)
const FormsSubmissionsInboxNeedsReviewSubmissionIdRoute =
  FormsSubmissionsInboxNeedsReviewSubmissionIdRouteImport.update({
    id: '/$submissionId',
    path: '/$submissionId',
    getParentRoute: () => FormsSubmissionsInboxNeedsReviewRoute,
  } as any)
const FormsSubmissionsInboxCompletedSubmissionIdRoute =
  FormsSubmissionsInboxCompletedSubmissionIdRouteImport.update({
    id: '/$submissionId',
    path: '/$submissionId',
    getParentRoute: () => FormsSubmissionsInboxCompletedRoute,
  } as any)
const FormsSubmissionsInboxAllSubmissionIdRoute =
  FormsSubmissionsInboxAllSubmissionIdRouteImport.update({
    id: '/$submissionId',
    path: '/$submissionId',
    getParentRoute: () => FormsSubmissionsInboxAllRoute,
  } as any)
const CallsVoicemailBoxesMailboxIdMessagesMessageIdRoute =
  CallsVoicemailBoxesMailboxIdMessagesMessageIdRouteImport.update({
    id: '/calls/voicemail-boxes/$mailboxId/messages/$messageId',
    path: '/calls/voicemail-boxes/$mailboxId/messages/$messageId',
    getParentRoute: () => rootRouteImport,
  } as any)
const BulkSubNavTypeIdViewRoute = BulkSubNavTypeIdViewRouteImport.update({
  id: '/bulk_/$subNav_/$type_/$id_/$view',
  path: '/bulk/$subNav/$type/$id/$view',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicUserInviteNonceTokenLocationLocationIdRoute =
  PublicUserInviteNonceTokenLocationLocationIdRouteImport.update({
    id: '/_public/user-invite_/$nonceToken_/location_/$locationId',
    path: '/user-invite/$nonceToken/location/$locationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const PublicPortingLoaLoaIdPdfRoute =
  PublicPortingLoaLoaIdPdfRouteImport.update({
    id: '/_public/porting_/loa_/$loaId_/pdf',
    path: '/porting/loa/$loaId/pdf',
    getParentRoute: () => rootRouteImport,
  } as any)
const PublicOnboardingDemoFormLocationIdDashboardRoute =
  PublicOnboardingDemoFormLocationIdDashboardRouteImport.update({
    id: '/$locationId_/dashboard',
    path: '/$locationId/dashboard',
    getParentRoute: () => PublicOnboardingDemoFormRoute,
  } as any)
const PublicOnboardingDemoFormLocationIdCompleteRoute =
  PublicOnboardingDemoFormLocationIdCompleteRouteImport.update({
    id: '/$locationId_/complete',
    path: '/$locationId/complete',
    getParentRoute: () => PublicOnboardingDemoFormRoute,
  } as any)
const PublicOnboardingDemoFormLocationIdSectionRoute =
  PublicOnboardingDemoFormLocationIdSectionRouteImport.update({
    id: '/$locationId_/$section',
    path: '/$locationId/$section',
    getParentRoute: () => PublicOnboardingDemoFormRoute,
  } as any)
const PublicAcceptInviteNonceTokenLocationLocationIdRoute =
  PublicAcceptInviteNonceTokenLocationLocationIdRouteImport.update({
    id: '/_public/accept-invite_/$nonceToken_/location_/$locationId',
    path: '/accept-invite/$nonceToken/location/$locationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const OnboardingFormLocationIdSectionTaskStepRoute =
  OnboardingFormLocationIdSectionTaskStepRouteImport.update({
    id: '/$locationId_/$section_/$task_/$step',
    path: '/$locationId/$section/$task/$step',
    getParentRoute: () => OnboardingFormRoute,
  } as any)
const PublicPortalUserInviteNonceTokenLocationLocationIdRoute =
  PublicPortalUserInviteNonceTokenLocationLocationIdRouteImport.update({
    id: '/_public/portal/user-invite_/$nonceToken_/location_/$locationId',
    path: '/portal/user-invite/$nonceToken/location/$locationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const PublicPortalAcceptInviteNonceTokenLocationLocationIdRoute =
  PublicPortalAcceptInviteNonceTokenLocationLocationIdRouteImport.update({
    id: '/_public/portal/accept-invite_/$nonceToken_/location_/$locationId',
    path: '/portal/accept-invite/$nonceToken/location/$locationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const PublicOnboardingDemoFormLocationIdSectionTaskStepRoute =
  PublicOnboardingDemoFormLocationIdSectionTaskStepRouteImport.update({
    id: '/$locationId_/$section_/$task_/$step',
    path: '/$locationId/$section/$task/$step',
    getParentRoute: () => PublicOnboardingDemoFormRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/bridgeline': typeof BridgelineRoute
  '/forms': typeof FormsRouteWithChildren
  '/onboard': typeof OnboardRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/parent': typeof ParentRoute
  '/weave-copilot': typeof WeaveCopilotRoute
  '/front-channel-logout': typeof PublicFrontChannelLogoutRoute
  '/hydra-error': typeof PublicHydraErrorRoute
  '/it-partner-quotes': typeof PublicItPartnerQuotesRoute
  '/login': typeof PublicLoginRoute
  '/okta-redirect': typeof PublicOktaRedirectRoute
  '/onboarding-demo': typeof PublicOnboardingDemoRouteWithChildren
  '/password-reset': typeof PublicPasswordResetRoute
  '/reset': typeof PublicResetRoute
  '/sign-in': typeof PublicSignInRoute
  '/analytics/ai-receptionist': typeof AnalyticsAiReceptionistRoute
  '/analytics/appointment': typeof AnalyticsAppointmentRoute
  '/analytics/auto-recall': typeof AnalyticsAutoRecallRoute
  '/analytics/call-intelligence': typeof AnalyticsCallIntelligenceRouteWithChildren
  '/analytics/dashboard': typeof AnalyticsDashboardRoute
  '/analytics/marketing-attribution': typeof AnalyticsMarketingAttributionRouteWithChildren
  '/analytics/messaging': typeof AnalyticsMessagingRoute
  '/analytics/phone': typeof AnalyticsPhoneRouteWithChildren
  '/analytics/practice': typeof AnalyticsPracticeRouteWithChildren
  '/analytics/reviews': typeof AnalyticsReviewsRoute
  '/analytics/roi': typeof AnalyticsRoiRouteWithChildren
  '/analytics/staff-performance': typeof AnalyticsStaffPerformanceRoute
  '/bulk/$subNav': typeof BulkSubNavRoute
  '/calls/call-history': typeof CallsCallHistoryRoute
  '/calls/call-queue-stats': typeof CallsCallQueueStatsRoute
  '/calls/team-presence': typeof CallsTeamPresenceRoute
  '/calls/voicemails': typeof CallsVoicemailsRoute
  '/contacts/$filter': typeof ContactsFilterRoute
  '/contacts/lists': typeof ContactsListsRoute
  '/fax/$filter': typeof FaxFilterRouteWithChildren
  '/forms/digitization': typeof FormsDigitizationRoute
  '/forms/kiosk': typeof FormsKioskRouteWithChildren
  '/forms/library': typeof FormsLibraryRouteWithChildren
  '/forms/submissions': typeof FormsSubmissionsRouteWithChildren
  '/forms/templates': typeof FormsTemplatesRoute
  '/home/dashboard': typeof HomeDashboardRoute
  '/home/onboarding': typeof HomeOnboardingRoute
  '/home/partners': typeof HomePartnersRoute
  '/messages/$filter': typeof MessagesFilterRouteWithChildren
  '/nr-auth-test/$id': typeof NrAuthTestIdRoute
  '/onboarding/form': typeof OnboardingFormRouteWithChildren
  '/payments/invoices': typeof PaymentsInvoicesRoute
  '/payments/payment-plans': typeof PaymentsPaymentPlansRoute
  '/payments/payouts': typeof PaymentsPayoutsRoute
  '/payments/refunds': typeof PaymentsRefundsRoute
  '/reviews/$site': typeof ReviewsSiteRouteWithChildren
  '/schedule/availability': typeof ScheduleAvailabilityRoute
  '/schedule/calendar': typeof ScheduleCalendarRoute
  '/schedule/debug': typeof ScheduleDebugRoute
  '/schedule/eligibility-list': typeof ScheduleEligibilityListRoute
  '/schedule/quickfill-history': typeof ScheduleQuickfillHistoryRoute
  '/schedule/request-history': typeof ScheduleRequestHistoryRoute
  '/schedule/schedule-activity': typeof ScheduleScheduleActivityRoute
  '/test/$id': typeof TestIdRoute
  '/test/error': typeof TestErrorRoute
  '/weave-admin/roles': typeof WeaveAdminRolesRoute
  '/x/parent': typeof XParentRouteWithChildren
  '/analytics': typeof AnalyticsIndexRoute
  '/bulk': typeof BulkIndexRoute
  '/calls': typeof CallsIndexRoute
  '/nr-public-test/$id': typeof PublicNrPublicTestIdRoute
  '/onboarding-demo/form': typeof PublicOnboardingDemoFormRouteWithChildren
  '/portal/login': typeof PublicPortalLoginRoute
  '/quotes/$quoteId': typeof PublicQuotesQuoteIdRoute
  '/reset-password/$nonceToken': typeof PublicResetPasswordNonceTokenRoute
  '/sign-in/callback': typeof PublicSignInCallbackRoute
  '/analytics/call-intelligence/$id': typeof AnalyticsCallIntelligenceIdRoute
  '/analytics/call-intelligence/main': typeof AnalyticsCallIntelligenceMainRoute
  '/analytics/marketing-attribution/main': typeof AnalyticsMarketingAttributionMainRoute
  '/analytics/phone/call-duration': typeof AnalyticsPhoneCallDurationRoute
  '/analytics/phone/call-volume': typeof AnalyticsPhoneCallVolumeRoute
  '/analytics/phone/main': typeof AnalyticsPhoneMainRoute
  '/analytics/phone/phone-tree-call-volume-all': typeof AnalyticsPhonePhoneTreeCallVolumeAllRoute
  '/analytics/practice/cancelled-appointments': typeof AnalyticsPracticeCancelledAppointmentsRoute
  '/analytics/practice/demographics': typeof AnalyticsPracticeDemographicsRoute
  '/analytics/practice/hygiene-follow-up': typeof AnalyticsPracticeHygieneFollowUpRoute
  '/analytics/practice/hygiene-treatment': typeof AnalyticsPracticeHygieneTreatmentRoute
  '/analytics/practice/main': typeof AnalyticsPracticeMainRoute
  '/analytics/practice/new-patients': typeof AnalyticsPracticeNewPatientsRoute
  '/analytics/practice/practitioner-analysis': typeof AnalyticsPracticePractitionerAnalysisRoute
  '/analytics/practice/recaptured-patients': typeof AnalyticsPracticeRecapturedPatientsRoute
  '/analytics/practice/restorative-treatment': typeof AnalyticsPracticeRestorativeTreatmentRoute
  '/analytics/practice/unscheduled-patients': typeof AnalyticsPracticeUnscheduledPatientsRoute
  '/analytics/roi/appointment-reminders': typeof AnalyticsRoiAppointmentRemindersRoute
  '/analytics/roi/bulk-text': typeof AnalyticsRoiBulkTextRoute
  '/analytics/roi/missed-call-text-conversion': typeof AnalyticsRoiMissedCallTextConversionRoute
  '/analytics/roi/no-show-rate': typeof AnalyticsRoiNoShowRateRoute
  '/bulk/$subNav/$type': typeof BulkSubNavTypeRoute
  '/fax/$filter/$faxId': typeof FaxFilterFaxIdRoute
  '/fax/drafts/$draftId': typeof FaxDraftsDraftIdRouteWithChildren
  '/fax/drafts/new': typeof FaxDraftsNewRoute
  '/fax/drafts/new-from-template': typeof FaxDraftsNewFromTemplateRoute
  '/fax/drafts/template-editor': typeof FaxDraftsTemplateEditorRoute
  '/forms/builder/$id': typeof FormsBuilderIdRoute
  '/forms/kiosk/patient-kiosk': typeof FormsKioskPatientKioskRoute
  '/forms/library/forms': typeof FormsLibraryFormsRoute
  '/forms/library/packets': typeof FormsLibraryPacketsRoute
  '/forms/submissions/archived': typeof FormsSubmissionsArchivedRouteWithChildren
  '/forms/submissions/inbox': typeof FormsSubmissionsInboxRouteWithChildren
  '/forms/submissions/sent': typeof FormsSubmissionsSentRouteWithChildren
  '/messages/$filter/new': typeof MessagesFilterNewRoute
  '/payments/invoices/$id': typeof PaymentsInvoicesIdRoute
  '/payments/payment-plans/$planId': typeof PaymentsPaymentPlansPlanIdRoute
  '/payments/payment-plans/create': typeof PaymentsPaymentPlansCreateRoute
  '/payments/payouts/$payoutId': typeof PaymentsPayoutsPayoutIdRoute
  '/payments/refunds/$invoiceId': typeof PaymentsRefundsInvoiceIdRoute
  '/reviews/$site/$reviewId': typeof ReviewsSiteReviewIdRoute
  '/x/parent/child': typeof XParentChildRoute
  '/x/redirect/1': typeof XRedirect1Route
  '/x/redirect/2': typeof XRedirect2Route
  '/it-partner-quotes/$quoteId/pdf': typeof PublicItPartnerQuotesQuoteIdPdfRoute
  '/porting/loa/$loaId': typeof PublicPortingLoaLoaIdRoute
  '/quotes/$quoteId/pdf': typeof PublicQuotesQuoteIdPdfRoute
  '/test/redirect/1': typeof PublicTestRedirect1Route
  '/test/redirect/2': typeof PublicTestRedirect2Route
  '/analytics/call-intelligence/follow-ups/$type': typeof AnalyticsCallIntelligenceFollowUpsTypeRoute
  '/analytics/call-intelligence/service-issue/$type': typeof AnalyticsCallIntelligenceServiceIssueTypeRoute
  '/analytics/marketing-attribution/campaign/$number': typeof AnalyticsMarketingAttributionCampaignNumberRoute
  '/bulk/$subNav/$type/$id': typeof BulkSubNavTypeIdRoute
  '/fax/drafts/$draftId/begin': typeof FaxDraftsDraftIdBeginRoute
  '/fax/drafts/$draftId/choose-template': typeof FaxDraftsDraftIdChooseTemplateRoute
  '/fax/drafts/$draftId/cover': typeof FaxDraftsDraftIdCoverRoute
  '/fax/drafts/$draftId/finalize': typeof FaxDraftsDraftIdFinalizeRoute
  '/fax/drafts/$draftId/upload': typeof FaxDraftsDraftIdUploadRoute
  '/forms/library/forms/$id': typeof FormsLibraryFormsIdRoute
  '/forms/library/packets/$id': typeof FormsLibraryPacketsIdRoute
  '/forms/submissions/archived/$submissionId': typeof FormsSubmissionsArchivedSubmissionIdRoute
  '/forms/submissions/inbox/all': typeof FormsSubmissionsInboxAllRouteWithChildren
  '/forms/submissions/inbox/completed': typeof FormsSubmissionsInboxCompletedRouteWithChildren
  '/forms/submissions/inbox/needs-review': typeof FormsSubmissionsInboxNeedsReviewRouteWithChildren
  '/forms/submissions/inbox/retry-sync': typeof FormsSubmissionsInboxRetrySyncRouteWithChildren
  '/forms/submissions/inbox/reviewed': typeof FormsSubmissionsInboxReviewedRouteWithChildren
  '/forms/submissions/inbox/sync-manually': typeof FormsSubmissionsInboxSyncManuallyRouteWithChildren
  '/forms/submissions/sent/$submissionId': typeof FormsSubmissionsSentSubmissionIdRoute
  '/messages/$filter/$groupId/$threadId': typeof MessagesFilterGroupIdThreadIdRoute
  '/onboarding/form/$locationId/$section': typeof OnboardingFormLocationIdSectionRoute
  '/onboarding/form/$locationId/complete': typeof OnboardingFormLocationIdCompleteRoute
  '/onboarding/form/$locationId/dashboard': typeof OnboardingFormLocationIdDashboardRoute
  '/payments/payouts/$payoutId/$locationId': typeof PaymentsPayoutsPayoutIdLocationIdRoute
  '/accept-invite/$nonceToken/location/$locationId': typeof PublicAcceptInviteNonceTokenLocationLocationIdRoute
  '/onboarding-demo/form/$locationId/$section': typeof PublicOnboardingDemoFormLocationIdSectionRoute
  '/onboarding-demo/form/$locationId/complete': typeof PublicOnboardingDemoFormLocationIdCompleteRoute
  '/onboarding-demo/form/$locationId/dashboard': typeof PublicOnboardingDemoFormLocationIdDashboardRoute
  '/porting/loa/$loaId/pdf': typeof PublicPortingLoaLoaIdPdfRoute
  '/user-invite/$nonceToken/location/$locationId': typeof PublicUserInviteNonceTokenLocationLocationIdRoute
  '/bulk/$subNav/$type/$id/$view': typeof BulkSubNavTypeIdViewRoute
  '/calls/voicemail-boxes/$mailboxId/messages/$messageId': typeof CallsVoicemailBoxesMailboxIdMessagesMessageIdRoute
  '/forms/submissions/inbox/all/$submissionId': typeof FormsSubmissionsInboxAllSubmissionIdRoute
  '/forms/submissions/inbox/completed/$submissionId': typeof FormsSubmissionsInboxCompletedSubmissionIdRoute
  '/forms/submissions/inbox/needs-review/$submissionId': typeof FormsSubmissionsInboxNeedsReviewSubmissionIdRoute
  '/forms/submissions/inbox/retry-sync/$submissionId': typeof FormsSubmissionsInboxRetrySyncSubmissionIdRoute
  '/forms/submissions/inbox/reviewed/$submissionId': typeof FormsSubmissionsInboxReviewedSubmissionIdRoute
  '/forms/submissions/inbox/sync-manually/$submissionId': typeof FormsSubmissionsInboxSyncManuallySubmissionIdRoute
  '/portal/accept-invite/$nonceToken/location/$locationId': typeof PublicPortalAcceptInviteNonceTokenLocationLocationIdRoute
  '/portal/user-invite/$nonceToken/location/$locationId': typeof PublicPortalUserInviteNonceTokenLocationLocationIdRoute
  '/onboarding/form/$locationId/$section/$task/$step': typeof OnboardingFormLocationIdSectionTaskStepRoute
  '/onboarding-demo/form/$locationId/$section/$task/$step': typeof PublicOnboardingDemoFormLocationIdSectionTaskStepRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/bridgeline': typeof BridgelineRoute
  '/forms': typeof FormsRouteWithChildren
  '/onboard': typeof OnboardRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/parent': typeof ParentRoute
  '/weave-copilot': typeof WeaveCopilotRoute
  '/front-channel-logout': typeof PublicFrontChannelLogoutRoute
  '/hydra-error': typeof PublicHydraErrorRoute
  '/it-partner-quotes': typeof PublicItPartnerQuotesRoute
  '/login': typeof PublicLoginRoute
  '/okta-redirect': typeof PublicOktaRedirectRoute
  '/onboarding-demo': typeof PublicOnboardingDemoRouteWithChildren
  '/password-reset': typeof PublicPasswordResetRoute
  '/reset': typeof PublicResetRoute
  '/sign-in': typeof PublicSignInRoute
  '/analytics/ai-receptionist': typeof AnalyticsAiReceptionistRoute
  '/analytics/appointment': typeof AnalyticsAppointmentRoute
  '/analytics/auto-recall': typeof AnalyticsAutoRecallRoute
  '/analytics/call-intelligence': typeof AnalyticsCallIntelligenceRouteWithChildren
  '/analytics/dashboard': typeof AnalyticsDashboardRoute
  '/analytics/marketing-attribution': typeof AnalyticsMarketingAttributionRouteWithChildren
  '/analytics/messaging': typeof AnalyticsMessagingRoute
  '/analytics/phone': typeof AnalyticsPhoneRouteWithChildren
  '/analytics/practice': typeof AnalyticsPracticeRouteWithChildren
  '/analytics/reviews': typeof AnalyticsReviewsRoute
  '/analytics/roi': typeof AnalyticsRoiRouteWithChildren
  '/analytics/staff-performance': typeof AnalyticsStaffPerformanceRoute
  '/bulk/$subNav': typeof BulkSubNavRoute
  '/calls/call-history': typeof CallsCallHistoryRoute
  '/calls/call-queue-stats': typeof CallsCallQueueStatsRoute
  '/calls/team-presence': typeof CallsTeamPresenceRoute
  '/calls/voicemails': typeof CallsVoicemailsRoute
  '/contacts/$filter': typeof ContactsFilterRoute
  '/contacts/lists': typeof ContactsListsRoute
  '/fax/$filter': typeof FaxFilterRouteWithChildren
  '/forms/digitization': typeof FormsDigitizationRoute
  '/forms/kiosk': typeof FormsKioskRouteWithChildren
  '/forms/library': typeof FormsLibraryRouteWithChildren
  '/forms/submissions': typeof FormsSubmissionsRouteWithChildren
  '/forms/templates': typeof FormsTemplatesRoute
  '/home/dashboard': typeof HomeDashboardRoute
  '/home/onboarding': typeof HomeOnboardingRoute
  '/home/partners': typeof HomePartnersRoute
  '/messages/$filter': typeof MessagesFilterRouteWithChildren
  '/nr-auth-test/$id': typeof NrAuthTestIdRoute
  '/onboarding/form': typeof OnboardingFormRouteWithChildren
  '/payments/invoices': typeof PaymentsInvoicesRoute
  '/payments/payment-plans': typeof PaymentsPaymentPlansRoute
  '/payments/payouts': typeof PaymentsPayoutsRoute
  '/payments/refunds': typeof PaymentsRefundsRoute
  '/reviews/$site': typeof ReviewsSiteRouteWithChildren
  '/schedule/availability': typeof ScheduleAvailabilityRoute
  '/schedule/calendar': typeof ScheduleCalendarRoute
  '/schedule/debug': typeof ScheduleDebugRoute
  '/schedule/eligibility-list': typeof ScheduleEligibilityListRoute
  '/schedule/quickfill-history': typeof ScheduleQuickfillHistoryRoute
  '/schedule/request-history': typeof ScheduleRequestHistoryRoute
  '/schedule/schedule-activity': typeof ScheduleScheduleActivityRoute
  '/test/$id': typeof TestIdRoute
  '/test/error': typeof TestErrorRoute
  '/weave-admin/roles': typeof WeaveAdminRolesRoute
  '/x/parent': typeof XParentRouteWithChildren
  '/analytics': typeof AnalyticsIndexRoute
  '/bulk': typeof BulkIndexRoute
  '/calls': typeof CallsIndexRoute
  '/nr-public-test/$id': typeof PublicNrPublicTestIdRoute
  '/onboarding-demo/form': typeof PublicOnboardingDemoFormRouteWithChildren
  '/portal/login': typeof PublicPortalLoginRoute
  '/quotes/$quoteId': typeof PublicQuotesQuoteIdRoute
  '/reset-password/$nonceToken': typeof PublicResetPasswordNonceTokenRoute
  '/sign-in/callback': typeof PublicSignInCallbackRoute
  '/analytics/call-intelligence/$id': typeof AnalyticsCallIntelligenceIdRoute
  '/analytics/call-intelligence/main': typeof AnalyticsCallIntelligenceMainRoute
  '/analytics/marketing-attribution/main': typeof AnalyticsMarketingAttributionMainRoute
  '/analytics/phone/call-duration': typeof AnalyticsPhoneCallDurationRoute
  '/analytics/phone/call-volume': typeof AnalyticsPhoneCallVolumeRoute
  '/analytics/phone/main': typeof AnalyticsPhoneMainRoute
  '/analytics/phone/phone-tree-call-volume-all': typeof AnalyticsPhonePhoneTreeCallVolumeAllRoute
  '/analytics/practice/cancelled-appointments': typeof AnalyticsPracticeCancelledAppointmentsRoute
  '/analytics/practice/demographics': typeof AnalyticsPracticeDemographicsRoute
  '/analytics/practice/hygiene-follow-up': typeof AnalyticsPracticeHygieneFollowUpRoute
  '/analytics/practice/hygiene-treatment': typeof AnalyticsPracticeHygieneTreatmentRoute
  '/analytics/practice/main': typeof AnalyticsPracticeMainRoute
  '/analytics/practice/new-patients': typeof AnalyticsPracticeNewPatientsRoute
  '/analytics/practice/practitioner-analysis': typeof AnalyticsPracticePractitionerAnalysisRoute
  '/analytics/practice/recaptured-patients': typeof AnalyticsPracticeRecapturedPatientsRoute
  '/analytics/practice/restorative-treatment': typeof AnalyticsPracticeRestorativeTreatmentRoute
  '/analytics/practice/unscheduled-patients': typeof AnalyticsPracticeUnscheduledPatientsRoute
  '/analytics/roi/appointment-reminders': typeof AnalyticsRoiAppointmentRemindersRoute
  '/analytics/roi/bulk-text': typeof AnalyticsRoiBulkTextRoute
  '/analytics/roi/missed-call-text-conversion': typeof AnalyticsRoiMissedCallTextConversionRoute
  '/analytics/roi/no-show-rate': typeof AnalyticsRoiNoShowRateRoute
  '/bulk/$subNav/$type': typeof BulkSubNavTypeRoute
  '/fax/$filter/$faxId': typeof FaxFilterFaxIdRoute
  '/fax/drafts/$draftId': typeof FaxDraftsDraftIdRouteWithChildren
  '/fax/drafts/new': typeof FaxDraftsNewRoute
  '/fax/drafts/new-from-template': typeof FaxDraftsNewFromTemplateRoute
  '/fax/drafts/template-editor': typeof FaxDraftsTemplateEditorRoute
  '/forms/builder/$id': typeof FormsBuilderIdRoute
  '/forms/kiosk/patient-kiosk': typeof FormsKioskPatientKioskRoute
  '/forms/library/forms': typeof FormsLibraryFormsRoute
  '/forms/library/packets': typeof FormsLibraryPacketsRoute
  '/forms/submissions/archived': typeof FormsSubmissionsArchivedRouteWithChildren
  '/forms/submissions/inbox': typeof FormsSubmissionsInboxRouteWithChildren
  '/forms/submissions/sent': typeof FormsSubmissionsSentRouteWithChildren
  '/messages/$filter/new': typeof MessagesFilterNewRoute
  '/payments/invoices/$id': typeof PaymentsInvoicesIdRoute
  '/payments/payment-plans/$planId': typeof PaymentsPaymentPlansPlanIdRoute
  '/payments/payment-plans/create': typeof PaymentsPaymentPlansCreateRoute
  '/payments/payouts/$payoutId': typeof PaymentsPayoutsPayoutIdRoute
  '/payments/refunds/$invoiceId': typeof PaymentsRefundsInvoiceIdRoute
  '/reviews/$site/$reviewId': typeof ReviewsSiteReviewIdRoute
  '/x/parent/child': typeof XParentChildRoute
  '/x/redirect/1': typeof XRedirect1Route
  '/x/redirect/2': typeof XRedirect2Route
  '/it-partner-quotes/$quoteId/pdf': typeof PublicItPartnerQuotesQuoteIdPdfRoute
  '/porting/loa/$loaId': typeof PublicPortingLoaLoaIdRoute
  '/quotes/$quoteId/pdf': typeof PublicQuotesQuoteIdPdfRoute
  '/test/redirect/1': typeof PublicTestRedirect1Route
  '/test/redirect/2': typeof PublicTestRedirect2Route
  '/analytics/call-intelligence/follow-ups/$type': typeof AnalyticsCallIntelligenceFollowUpsTypeRoute
  '/analytics/call-intelligence/service-issue/$type': typeof AnalyticsCallIntelligenceServiceIssueTypeRoute
  '/analytics/marketing-attribution/campaign/$number': typeof AnalyticsMarketingAttributionCampaignNumberRoute
  '/bulk/$subNav/$type/$id': typeof BulkSubNavTypeIdRoute
  '/fax/drafts/$draftId/begin': typeof FaxDraftsDraftIdBeginRoute
  '/fax/drafts/$draftId/choose-template': typeof FaxDraftsDraftIdChooseTemplateRoute
  '/fax/drafts/$draftId/cover': typeof FaxDraftsDraftIdCoverRoute
  '/fax/drafts/$draftId/finalize': typeof FaxDraftsDraftIdFinalizeRoute
  '/fax/drafts/$draftId/upload': typeof FaxDraftsDraftIdUploadRoute
  '/forms/library/forms/$id': typeof FormsLibraryFormsIdRoute
  '/forms/library/packets/$id': typeof FormsLibraryPacketsIdRoute
  '/forms/submissions/archived/$submissionId': typeof FormsSubmissionsArchivedSubmissionIdRoute
  '/forms/submissions/inbox/all': typeof FormsSubmissionsInboxAllRouteWithChildren
  '/forms/submissions/inbox/completed': typeof FormsSubmissionsInboxCompletedRouteWithChildren
  '/forms/submissions/inbox/needs-review': typeof FormsSubmissionsInboxNeedsReviewRouteWithChildren
  '/forms/submissions/inbox/retry-sync': typeof FormsSubmissionsInboxRetrySyncRouteWithChildren
  '/forms/submissions/inbox/reviewed': typeof FormsSubmissionsInboxReviewedRouteWithChildren
  '/forms/submissions/inbox/sync-manually': typeof FormsSubmissionsInboxSyncManuallyRouteWithChildren
  '/forms/submissions/sent/$submissionId': typeof FormsSubmissionsSentSubmissionIdRoute
  '/messages/$filter/$groupId/$threadId': typeof MessagesFilterGroupIdThreadIdRoute
  '/onboarding/form/$locationId/$section': typeof OnboardingFormLocationIdSectionRoute
  '/onboarding/form/$locationId/complete': typeof OnboardingFormLocationIdCompleteRoute
  '/onboarding/form/$locationId/dashboard': typeof OnboardingFormLocationIdDashboardRoute
  '/payments/payouts/$payoutId/$locationId': typeof PaymentsPayoutsPayoutIdLocationIdRoute
  '/accept-invite/$nonceToken/location/$locationId': typeof PublicAcceptInviteNonceTokenLocationLocationIdRoute
  '/onboarding-demo/form/$locationId/$section': typeof PublicOnboardingDemoFormLocationIdSectionRoute
  '/onboarding-demo/form/$locationId/complete': typeof PublicOnboardingDemoFormLocationIdCompleteRoute
  '/onboarding-demo/form/$locationId/dashboard': typeof PublicOnboardingDemoFormLocationIdDashboardRoute
  '/porting/loa/$loaId/pdf': typeof PublicPortingLoaLoaIdPdfRoute
  '/user-invite/$nonceToken/location/$locationId': typeof PublicUserInviteNonceTokenLocationLocationIdRoute
  '/bulk/$subNav/$type/$id/$view': typeof BulkSubNavTypeIdViewRoute
  '/calls/voicemail-boxes/$mailboxId/messages/$messageId': typeof CallsVoicemailBoxesMailboxIdMessagesMessageIdRoute
  '/forms/submissions/inbox/all/$submissionId': typeof FormsSubmissionsInboxAllSubmissionIdRoute
  '/forms/submissions/inbox/completed/$submissionId': typeof FormsSubmissionsInboxCompletedSubmissionIdRoute
  '/forms/submissions/inbox/needs-review/$submissionId': typeof FormsSubmissionsInboxNeedsReviewSubmissionIdRoute
  '/forms/submissions/inbox/retry-sync/$submissionId': typeof FormsSubmissionsInboxRetrySyncSubmissionIdRoute
  '/forms/submissions/inbox/reviewed/$submissionId': typeof FormsSubmissionsInboxReviewedSubmissionIdRoute
  '/forms/submissions/inbox/sync-manually/$submissionId': typeof FormsSubmissionsInboxSyncManuallySubmissionIdRoute
  '/portal/accept-invite/$nonceToken/location/$locationId': typeof PublicPortalAcceptInviteNonceTokenLocationLocationIdRoute
  '/portal/user-invite/$nonceToken/location/$locationId': typeof PublicPortalUserInviteNonceTokenLocationLocationIdRoute
  '/onboarding/form/$locationId/$section/$task/$step': typeof OnboardingFormLocationIdSectionTaskStepRoute
  '/onboarding-demo/form/$locationId/$section/$task/$step': typeof PublicOnboardingDemoFormLocationIdSectionTaskStepRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/bridgeline': typeof BridgelineRoute
  '/forms': typeof FormsRouteWithChildren
  '/onboard': typeof OnboardRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/parent': typeof ParentRoute
  '/weave-copilot': typeof WeaveCopilotRoute
  '/_public/front-channel-logout': typeof PublicFrontChannelLogoutRoute
  '/_public/hydra-error': typeof PublicHydraErrorRoute
  '/_public/it-partner-quotes': typeof PublicItPartnerQuotesRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/okta-redirect': typeof PublicOktaRedirectRoute
  '/_public/onboarding-demo': typeof PublicOnboardingDemoRouteWithChildren
  '/_public/password-reset': typeof PublicPasswordResetRoute
  '/_public/reset': typeof PublicResetRoute
  '/_public/sign-in': typeof PublicSignInRoute
  '/analytics/ai-receptionist': typeof AnalyticsAiReceptionistRoute
  '/analytics/appointment': typeof AnalyticsAppointmentRoute
  '/analytics/auto-recall': typeof AnalyticsAutoRecallRoute
  '/analytics/call-intelligence': typeof AnalyticsCallIntelligenceRouteWithChildren
  '/analytics/dashboard': typeof AnalyticsDashboardRoute
  '/analytics/marketing-attribution': typeof AnalyticsMarketingAttributionRouteWithChildren
  '/analytics/messaging': typeof AnalyticsMessagingRoute
  '/analytics/phone': typeof AnalyticsPhoneRouteWithChildren
  '/analytics/practice': typeof AnalyticsPracticeRouteWithChildren
  '/analytics/reviews': typeof AnalyticsReviewsRoute
  '/analytics/roi': typeof AnalyticsRoiRouteWithChildren
  '/analytics/staff-performance': typeof AnalyticsStaffPerformanceRoute
  '/bulk_/$subNav': typeof BulkSubNavRoute
  '/calls/call-history': typeof CallsCallHistoryRoute
  '/calls/call-queue-stats': typeof CallsCallQueueStatsRoute
  '/calls/team-presence': typeof CallsTeamPresenceRoute
  '/calls/voicemails': typeof CallsVoicemailsRoute
  '/contacts/$filter': typeof ContactsFilterRoute
  '/contacts/lists': typeof ContactsListsRoute
  '/fax/$filter': typeof FaxFilterRouteWithChildren
  '/forms/digitization': typeof FormsDigitizationRoute
  '/forms/kiosk': typeof FormsKioskRouteWithChildren
  '/forms/library': typeof FormsLibraryRouteWithChildren
  '/forms/submissions': typeof FormsSubmissionsRouteWithChildren
  '/forms/templates': typeof FormsTemplatesRoute
  '/home/dashboard': typeof HomeDashboardRoute
  '/home/onboarding': typeof HomeOnboardingRoute
  '/home/partners': typeof HomePartnersRoute
  '/messages/$filter': typeof MessagesFilterRouteWithChildren
  '/nr-auth-test/$id': typeof NrAuthTestIdRoute
  '/onboarding/form': typeof OnboardingFormRouteWithChildren
  '/payments/invoices': typeof PaymentsInvoicesRoute
  '/payments/payment-plans': typeof PaymentsPaymentPlansRoute
  '/payments/payouts': typeof PaymentsPayoutsRoute
  '/payments/refunds': typeof PaymentsRefundsRoute
  '/reviews/$site': typeof ReviewsSiteRouteWithChildren
  '/schedule/availability': typeof ScheduleAvailabilityRoute
  '/schedule/calendar': typeof ScheduleCalendarRoute
  '/schedule/debug': typeof ScheduleDebugRoute
  '/schedule/eligibility-list': typeof ScheduleEligibilityListRoute
  '/schedule/quickfill-history': typeof ScheduleQuickfillHistoryRoute
  '/schedule/request-history': typeof ScheduleRequestHistoryRoute
  '/schedule/schedule-activity': typeof ScheduleScheduleActivityRoute
  '/test/$id': typeof TestIdRoute
  '/test_/error': typeof TestErrorRoute
  '/weave-admin/roles': typeof WeaveAdminRolesRoute
  '/x_/parent': typeof XParentRouteWithChildren
  '/analytics/': typeof AnalyticsIndexRoute
  '/bulk_/': typeof BulkIndexRoute
  '/calls/': typeof CallsIndexRoute
  '/_public/nr-public-test/$id': typeof PublicNrPublicTestIdRoute
  '/_public/onboarding-demo/form': typeof PublicOnboardingDemoFormRouteWithChildren
  '/_public/portal/login': typeof PublicPortalLoginRoute
  '/_public/quotes_/$quoteId': typeof PublicQuotesQuoteIdRoute
  '/_public/reset-password_/$nonceToken': typeof PublicResetPasswordNonceTokenRoute
  '/_public/sign-in_/callback': typeof PublicSignInCallbackRoute
  '/analytics/call-intelligence/$id': typeof AnalyticsCallIntelligenceIdRoute
  '/analytics/call-intelligence/main': typeof AnalyticsCallIntelligenceMainRoute
  '/analytics/marketing-attribution/main': typeof AnalyticsMarketingAttributionMainRoute
  '/analytics/phone/call-duration': typeof AnalyticsPhoneCallDurationRoute
  '/analytics/phone/call-volume': typeof AnalyticsPhoneCallVolumeRoute
  '/analytics/phone/main': typeof AnalyticsPhoneMainRoute
  '/analytics/phone/phone-tree-call-volume-all': typeof AnalyticsPhonePhoneTreeCallVolumeAllRoute
  '/analytics/practice/cancelled-appointments': typeof AnalyticsPracticeCancelledAppointmentsRoute
  '/analytics/practice/demographics': typeof AnalyticsPracticeDemographicsRoute
  '/analytics/practice/hygiene-follow-up': typeof AnalyticsPracticeHygieneFollowUpRoute
  '/analytics/practice/hygiene-treatment': typeof AnalyticsPracticeHygieneTreatmentRoute
  '/analytics/practice/main': typeof AnalyticsPracticeMainRoute
  '/analytics/practice/new-patients': typeof AnalyticsPracticeNewPatientsRoute
  '/analytics/practice/practitioner-analysis': typeof AnalyticsPracticePractitionerAnalysisRoute
  '/analytics/practice/recaptured-patients': typeof AnalyticsPracticeRecapturedPatientsRoute
  '/analytics/practice/restorative-treatment': typeof AnalyticsPracticeRestorativeTreatmentRoute
  '/analytics/practice/unscheduled-patients': typeof AnalyticsPracticeUnscheduledPatientsRoute
  '/analytics/roi/appointment-reminders': typeof AnalyticsRoiAppointmentRemindersRoute
  '/analytics/roi/bulk-text': typeof AnalyticsRoiBulkTextRoute
  '/analytics/roi/missed-call-text-conversion': typeof AnalyticsRoiMissedCallTextConversionRoute
  '/analytics/roi/no-show-rate': typeof AnalyticsRoiNoShowRateRoute
  '/bulk_/$subNav_/$type': typeof BulkSubNavTypeRoute
  '/fax/$filter/$faxId': typeof FaxFilterFaxIdRoute
  '/fax/drafts/$draftId': typeof FaxDraftsDraftIdRouteWithChildren
  '/fax/drafts/new': typeof FaxDraftsNewRoute
  '/fax/drafts/new-from-template': typeof FaxDraftsNewFromTemplateRoute
  '/fax/drafts/template-editor': typeof FaxDraftsTemplateEditorRoute
  '/forms/builder_/$id': typeof FormsBuilderIdRoute
  '/forms/kiosk/patient-kiosk': typeof FormsKioskPatientKioskRoute
  '/forms/library/forms': typeof FormsLibraryFormsRoute
  '/forms/library/packets': typeof FormsLibraryPacketsRoute
  '/forms/submissions/archived': typeof FormsSubmissionsArchivedRouteWithChildren
  '/forms/submissions/inbox': typeof FormsSubmissionsInboxRouteWithChildren
  '/forms/submissions/sent': typeof FormsSubmissionsSentRouteWithChildren
  '/messages/$filter/new': typeof MessagesFilterNewRoute
  '/payments/invoices_/$id': typeof PaymentsInvoicesIdRoute
  '/payments/payment-plans_/$planId': typeof PaymentsPaymentPlansPlanIdRoute
  '/payments/payment-plans_/create': typeof PaymentsPaymentPlansCreateRoute
  '/payments/payouts_/$payoutId': typeof PaymentsPayoutsPayoutIdRoute
  '/payments/refunds_/$invoiceId': typeof PaymentsRefundsInvoiceIdRoute
  '/reviews/$site/$reviewId': typeof ReviewsSiteReviewIdRoute
  '/x_/parent/child': typeof XParentChildRoute
  '/x_/redirect_/1': typeof XRedirect1Route
  '/x_/redirect_/2': typeof XRedirect2Route
  '/_public/it-partner-quotes_/$quoteId_/pdf': typeof PublicItPartnerQuotesQuoteIdPdfRoute
  '/_public/porting_/loa_/$loaId': typeof PublicPortingLoaLoaIdRoute
  '/_public/quotes_/$quoteId_/pdf': typeof PublicQuotesQuoteIdPdfRoute
  '/_public/test_/redirect_/1': typeof PublicTestRedirect1Route
  '/_public/test_/redirect_/2': typeof PublicTestRedirect2Route
  '/analytics/call-intelligence/follow-ups_/$type': typeof AnalyticsCallIntelligenceFollowUpsTypeRoute
  '/analytics/call-intelligence/service-issue_/$type': typeof AnalyticsCallIntelligenceServiceIssueTypeRoute
  '/analytics/marketing-attribution/campaign_/$number': typeof AnalyticsMarketingAttributionCampaignNumberRoute
  '/bulk_/$subNav_/$type_/$id': typeof BulkSubNavTypeIdRoute
  '/fax/drafts/$draftId/begin': typeof FaxDraftsDraftIdBeginRoute
  '/fax/drafts/$draftId/choose-template': typeof FaxDraftsDraftIdChooseTemplateRoute
  '/fax/drafts/$draftId/cover': typeof FaxDraftsDraftIdCoverRoute
  '/fax/drafts/$draftId/finalize': typeof FaxDraftsDraftIdFinalizeRoute
  '/fax/drafts/$draftId/upload': typeof FaxDraftsDraftIdUploadRoute
  '/forms/library/forms_/$id': typeof FormsLibraryFormsIdRoute
  '/forms/library/packets_/$id': typeof FormsLibraryPacketsIdRoute
  '/forms/submissions/archived/$submissionId': typeof FormsSubmissionsArchivedSubmissionIdRoute
  '/forms/submissions/inbox/all': typeof FormsSubmissionsInboxAllRouteWithChildren
  '/forms/submissions/inbox/completed': typeof FormsSubmissionsInboxCompletedRouteWithChildren
  '/forms/submissions/inbox/needs-review': typeof FormsSubmissionsInboxNeedsReviewRouteWithChildren
  '/forms/submissions/inbox/retry-sync': typeof FormsSubmissionsInboxRetrySyncRouteWithChildren
  '/forms/submissions/inbox/reviewed': typeof FormsSubmissionsInboxReviewedRouteWithChildren
  '/forms/submissions/inbox/sync-manually': typeof FormsSubmissionsInboxSyncManuallyRouteWithChildren
  '/forms/submissions/sent/$submissionId': typeof FormsSubmissionsSentSubmissionIdRoute
  '/messages/$filter/$groupId_/$threadId': typeof MessagesFilterGroupIdThreadIdRoute
  '/onboarding/form/$locationId_/$section': typeof OnboardingFormLocationIdSectionRoute
  '/onboarding/form/$locationId_/complete': typeof OnboardingFormLocationIdCompleteRoute
  '/onboarding/form/$locationId_/dashboard': typeof OnboardingFormLocationIdDashboardRoute
  '/payments/payouts_/$payoutId_/$locationId': typeof PaymentsPayoutsPayoutIdLocationIdRoute
  '/_public/accept-invite_/$nonceToken_/location_/$locationId': typeof PublicAcceptInviteNonceTokenLocationLocationIdRoute
  '/_public/onboarding-demo/form/$locationId_/$section': typeof PublicOnboardingDemoFormLocationIdSectionRoute
  '/_public/onboarding-demo/form/$locationId_/complete': typeof PublicOnboardingDemoFormLocationIdCompleteRoute
  '/_public/onboarding-demo/form/$locationId_/dashboard': typeof PublicOnboardingDemoFormLocationIdDashboardRoute
  '/_public/porting_/loa_/$loaId_/pdf': typeof PublicPortingLoaLoaIdPdfRoute
  '/_public/user-invite_/$nonceToken_/location_/$locationId': typeof PublicUserInviteNonceTokenLocationLocationIdRoute
  '/bulk_/$subNav_/$type_/$id_/$view': typeof BulkSubNavTypeIdViewRoute
  '/calls/voicemail-boxes/$mailboxId/messages/$messageId': typeof CallsVoicemailBoxesMailboxIdMessagesMessageIdRoute
  '/forms/submissions/inbox/all/$submissionId': typeof FormsSubmissionsInboxAllSubmissionIdRoute
  '/forms/submissions/inbox/completed/$submissionId': typeof FormsSubmissionsInboxCompletedSubmissionIdRoute
  '/forms/submissions/inbox/needs-review/$submissionId': typeof FormsSubmissionsInboxNeedsReviewSubmissionIdRoute
  '/forms/submissions/inbox/retry-sync/$submissionId': typeof FormsSubmissionsInboxRetrySyncSubmissionIdRoute
  '/forms/submissions/inbox/reviewed/$submissionId': typeof FormsSubmissionsInboxReviewedSubmissionIdRoute
  '/forms/submissions/inbox/sync-manually/$submissionId': typeof FormsSubmissionsInboxSyncManuallySubmissionIdRoute
  '/_public/portal/accept-invite_/$nonceToken_/location_/$locationId': typeof PublicPortalAcceptInviteNonceTokenLocationLocationIdRoute
  '/_public/portal/user-invite_/$nonceToken_/location_/$locationId': typeof PublicPortalUserInviteNonceTokenLocationLocationIdRoute
  '/onboarding/form/$locationId_/$section_/$task_/$step': typeof OnboardingFormLocationIdSectionTaskStepRoute
  '/_public/onboarding-demo/form/$locationId_/$section_/$task_/$step': typeof PublicOnboardingDemoFormLocationIdSectionTaskStepRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/bridgeline'
    | '/forms'
    | '/onboard'
    | '/onboarding'
    | '/parent'
    | '/weave-copilot'
    | '/front-channel-logout'
    | '/hydra-error'
    | '/it-partner-quotes'
    | '/login'
    | '/okta-redirect'
    | '/onboarding-demo'
    | '/password-reset'
    | '/reset'
    | '/sign-in'
    | '/analytics/ai-receptionist'
    | '/analytics/appointment'
    | '/analytics/auto-recall'
    | '/analytics/call-intelligence'
    | '/analytics/dashboard'
    | '/analytics/marketing-attribution'
    | '/analytics/messaging'
    | '/analytics/phone'
    | '/analytics/practice'
    | '/analytics/reviews'
    | '/analytics/roi'
    | '/analytics/staff-performance'
    | '/bulk/$subNav'
    | '/calls/call-history'
    | '/calls/call-queue-stats'
    | '/calls/team-presence'
    | '/calls/voicemails'
    | '/contacts/$filter'
    | '/contacts/lists'
    | '/fax/$filter'
    | '/forms/digitization'
    | '/forms/kiosk'
    | '/forms/library'
    | '/forms/submissions'
    | '/forms/templates'
    | '/home/dashboard'
    | '/home/onboarding'
    | '/home/partners'
    | '/messages/$filter'
    | '/nr-auth-test/$id'
    | '/onboarding/form'
    | '/payments/invoices'
    | '/payments/payment-plans'
    | '/payments/payouts'
    | '/payments/refunds'
    | '/reviews/$site'
    | '/schedule/availability'
    | '/schedule/calendar'
    | '/schedule/debug'
    | '/schedule/eligibility-list'
    | '/schedule/quickfill-history'
    | '/schedule/request-history'
    | '/schedule/schedule-activity'
    | '/test/$id'
    | '/test/error'
    | '/weave-admin/roles'
    | '/x/parent'
    | '/analytics'
    | '/bulk'
    | '/calls'
    | '/nr-public-test/$id'
    | '/onboarding-demo/form'
    | '/portal/login'
    | '/quotes/$quoteId'
    | '/reset-password/$nonceToken'
    | '/sign-in/callback'
    | '/analytics/call-intelligence/$id'
    | '/analytics/call-intelligence/main'
    | '/analytics/marketing-attribution/main'
    | '/analytics/phone/call-duration'
    | '/analytics/phone/call-volume'
    | '/analytics/phone/main'
    | '/analytics/phone/phone-tree-call-volume-all'
    | '/analytics/practice/cancelled-appointments'
    | '/analytics/practice/demographics'
    | '/analytics/practice/hygiene-follow-up'
    | '/analytics/practice/hygiene-treatment'
    | '/analytics/practice/main'
    | '/analytics/practice/new-patients'
    | '/analytics/practice/practitioner-analysis'
    | '/analytics/practice/recaptured-patients'
    | '/analytics/practice/restorative-treatment'
    | '/analytics/practice/unscheduled-patients'
    | '/analytics/roi/appointment-reminders'
    | '/analytics/roi/bulk-text'
    | '/analytics/roi/missed-call-text-conversion'
    | '/analytics/roi/no-show-rate'
    | '/bulk/$subNav/$type'
    | '/fax/$filter/$faxId'
    | '/fax/drafts/$draftId'
    | '/fax/drafts/new'
    | '/fax/drafts/new-from-template'
    | '/fax/drafts/template-editor'
    | '/forms/builder/$id'
    | '/forms/kiosk/patient-kiosk'
    | '/forms/library/forms'
    | '/forms/library/packets'
    | '/forms/submissions/archived'
    | '/forms/submissions/inbox'
    | '/forms/submissions/sent'
    | '/messages/$filter/new'
    | '/payments/invoices/$id'
    | '/payments/payment-plans/$planId'
    | '/payments/payment-plans/create'
    | '/payments/payouts/$payoutId'
    | '/payments/refunds/$invoiceId'
    | '/reviews/$site/$reviewId'
    | '/x/parent/child'
    | '/x/redirect/1'
    | '/x/redirect/2'
    | '/it-partner-quotes/$quoteId/pdf'
    | '/porting/loa/$loaId'
    | '/quotes/$quoteId/pdf'
    | '/test/redirect/1'
    | '/test/redirect/2'
    | '/analytics/call-intelligence/follow-ups/$type'
    | '/analytics/call-intelligence/service-issue/$type'
    | '/analytics/marketing-attribution/campaign/$number'
    | '/bulk/$subNav/$type/$id'
    | '/fax/drafts/$draftId/begin'
    | '/fax/drafts/$draftId/choose-template'
    | '/fax/drafts/$draftId/cover'
    | '/fax/drafts/$draftId/finalize'
    | '/fax/drafts/$draftId/upload'
    | '/forms/library/forms/$id'
    | '/forms/library/packets/$id'
    | '/forms/submissions/archived/$submissionId'
    | '/forms/submissions/inbox/all'
    | '/forms/submissions/inbox/completed'
    | '/forms/submissions/inbox/needs-review'
    | '/forms/submissions/inbox/retry-sync'
    | '/forms/submissions/inbox/reviewed'
    | '/forms/submissions/inbox/sync-manually'
    | '/forms/submissions/sent/$submissionId'
    | '/messages/$filter/$groupId/$threadId'
    | '/onboarding/form/$locationId/$section'
    | '/onboarding/form/$locationId/complete'
    | '/onboarding/form/$locationId/dashboard'
    | '/payments/payouts/$payoutId/$locationId'
    | '/accept-invite/$nonceToken/location/$locationId'
    | '/onboarding-demo/form/$locationId/$section'
    | '/onboarding-demo/form/$locationId/complete'
    | '/onboarding-demo/form/$locationId/dashboard'
    | '/porting/loa/$loaId/pdf'
    | '/user-invite/$nonceToken/location/$locationId'
    | '/bulk/$subNav/$type/$id/$view'
    | '/calls/voicemail-boxes/$mailboxId/messages/$messageId'
    | '/forms/submissions/inbox/all/$submissionId'
    | '/forms/submissions/inbox/completed/$submissionId'
    | '/forms/submissions/inbox/needs-review/$submissionId'
    | '/forms/submissions/inbox/retry-sync/$submissionId'
    | '/forms/submissions/inbox/reviewed/$submissionId'
    | '/forms/submissions/inbox/sync-manually/$submissionId'
    | '/portal/accept-invite/$nonceToken/location/$locationId'
    | '/portal/user-invite/$nonceToken/location/$locationId'
    | '/onboarding/form/$locationId/$section/$task/$step'
    | '/onboarding-demo/form/$locationId/$section/$task/$step'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/bridgeline'
    | '/forms'
    | '/onboard'
    | '/onboarding'
    | '/parent'
    | '/weave-copilot'
    | '/front-channel-logout'
    | '/hydra-error'
    | '/it-partner-quotes'
    | '/login'
    | '/okta-redirect'
    | '/onboarding-demo'
    | '/password-reset'
    | '/reset'
    | '/sign-in'
    | '/analytics/ai-receptionist'
    | '/analytics/appointment'
    | '/analytics/auto-recall'
    | '/analytics/call-intelligence'
    | '/analytics/dashboard'
    | '/analytics/marketing-attribution'
    | '/analytics/messaging'
    | '/analytics/phone'
    | '/analytics/practice'
    | '/analytics/reviews'
    | '/analytics/roi'
    | '/analytics/staff-performance'
    | '/bulk/$subNav'
    | '/calls/call-history'
    | '/calls/call-queue-stats'
    | '/calls/team-presence'
    | '/calls/voicemails'
    | '/contacts/$filter'
    | '/contacts/lists'
    | '/fax/$filter'
    | '/forms/digitization'
    | '/forms/kiosk'
    | '/forms/library'
    | '/forms/submissions'
    | '/forms/templates'
    | '/home/dashboard'
    | '/home/onboarding'
    | '/home/partners'
    | '/messages/$filter'
    | '/nr-auth-test/$id'
    | '/onboarding/form'
    | '/payments/invoices'
    | '/payments/payment-plans'
    | '/payments/payouts'
    | '/payments/refunds'
    | '/reviews/$site'
    | '/schedule/availability'
    | '/schedule/calendar'
    | '/schedule/debug'
    | '/schedule/eligibility-list'
    | '/schedule/quickfill-history'
    | '/schedule/request-history'
    | '/schedule/schedule-activity'
    | '/test/$id'
    | '/test/error'
    | '/weave-admin/roles'
    | '/x/parent'
    | '/analytics'
    | '/bulk'
    | '/calls'
    | '/nr-public-test/$id'
    | '/onboarding-demo/form'
    | '/portal/login'
    | '/quotes/$quoteId'
    | '/reset-password/$nonceToken'
    | '/sign-in/callback'
    | '/analytics/call-intelligence/$id'
    | '/analytics/call-intelligence/main'
    | '/analytics/marketing-attribution/main'
    | '/analytics/phone/call-duration'
    | '/analytics/phone/call-volume'
    | '/analytics/phone/main'
    | '/analytics/phone/phone-tree-call-volume-all'
    | '/analytics/practice/cancelled-appointments'
    | '/analytics/practice/demographics'
    | '/analytics/practice/hygiene-follow-up'
    | '/analytics/practice/hygiene-treatment'
    | '/analytics/practice/main'
    | '/analytics/practice/new-patients'
    | '/analytics/practice/practitioner-analysis'
    | '/analytics/practice/recaptured-patients'
    | '/analytics/practice/restorative-treatment'
    | '/analytics/practice/unscheduled-patients'
    | '/analytics/roi/appointment-reminders'
    | '/analytics/roi/bulk-text'
    | '/analytics/roi/missed-call-text-conversion'
    | '/analytics/roi/no-show-rate'
    | '/bulk/$subNav/$type'
    | '/fax/$filter/$faxId'
    | '/fax/drafts/$draftId'
    | '/fax/drafts/new'
    | '/fax/drafts/new-from-template'
    | '/fax/drafts/template-editor'
    | '/forms/builder/$id'
    | '/forms/kiosk/patient-kiosk'
    | '/forms/library/forms'
    | '/forms/library/packets'
    | '/forms/submissions/archived'
    | '/forms/submissions/inbox'
    | '/forms/submissions/sent'
    | '/messages/$filter/new'
    | '/payments/invoices/$id'
    | '/payments/payment-plans/$planId'
    | '/payments/payment-plans/create'
    | '/payments/payouts/$payoutId'
    | '/payments/refunds/$invoiceId'
    | '/reviews/$site/$reviewId'
    | '/x/parent/child'
    | '/x/redirect/1'
    | '/x/redirect/2'
    | '/it-partner-quotes/$quoteId/pdf'
    | '/porting/loa/$loaId'
    | '/quotes/$quoteId/pdf'
    | '/test/redirect/1'
    | '/test/redirect/2'
    | '/analytics/call-intelligence/follow-ups/$type'
    | '/analytics/call-intelligence/service-issue/$type'
    | '/analytics/marketing-attribution/campaign/$number'
    | '/bulk/$subNav/$type/$id'
    | '/fax/drafts/$draftId/begin'
    | '/fax/drafts/$draftId/choose-template'
    | '/fax/drafts/$draftId/cover'
    | '/fax/drafts/$draftId/finalize'
    | '/fax/drafts/$draftId/upload'
    | '/forms/library/forms/$id'
    | '/forms/library/packets/$id'
    | '/forms/submissions/archived/$submissionId'
    | '/forms/submissions/inbox/all'
    | '/forms/submissions/inbox/completed'
    | '/forms/submissions/inbox/needs-review'
    | '/forms/submissions/inbox/retry-sync'
    | '/forms/submissions/inbox/reviewed'
    | '/forms/submissions/inbox/sync-manually'
    | '/forms/submissions/sent/$submissionId'
    | '/messages/$filter/$groupId/$threadId'
    | '/onboarding/form/$locationId/$section'
    | '/onboarding/form/$locationId/complete'
    | '/onboarding/form/$locationId/dashboard'
    | '/payments/payouts/$payoutId/$locationId'
    | '/accept-invite/$nonceToken/location/$locationId'
    | '/onboarding-demo/form/$locationId/$section'
    | '/onboarding-demo/form/$locationId/complete'
    | '/onboarding-demo/form/$locationId/dashboard'
    | '/porting/loa/$loaId/pdf'
    | '/user-invite/$nonceToken/location/$locationId'
    | '/bulk/$subNav/$type/$id/$view'
    | '/calls/voicemail-boxes/$mailboxId/messages/$messageId'
    | '/forms/submissions/inbox/all/$submissionId'
    | '/forms/submissions/inbox/completed/$submissionId'
    | '/forms/submissions/inbox/needs-review/$submissionId'
    | '/forms/submissions/inbox/retry-sync/$submissionId'
    | '/forms/submissions/inbox/reviewed/$submissionId'
    | '/forms/submissions/inbox/sync-manually/$submissionId'
    | '/portal/accept-invite/$nonceToken/location/$locationId'
    | '/portal/user-invite/$nonceToken/location/$locationId'
    | '/onboarding/form/$locationId/$section/$task/$step'
    | '/onboarding-demo/form/$locationId/$section/$task/$step'
  id:
    | '__root__'
    | '/'
    | '/bridgeline'
    | '/forms'
    | '/onboard'
    | '/onboarding'
    | '/parent'
    | '/weave-copilot'
    | '/_public/front-channel-logout'
    | '/_public/hydra-error'
    | '/_public/it-partner-quotes'
    | '/_public/login'
    | '/_public/okta-redirect'
    | '/_public/onboarding-demo'
    | '/_public/password-reset'
    | '/_public/reset'
    | '/_public/sign-in'
    | '/analytics/ai-receptionist'
    | '/analytics/appointment'
    | '/analytics/auto-recall'
    | '/analytics/call-intelligence'
    | '/analytics/dashboard'
    | '/analytics/marketing-attribution'
    | '/analytics/messaging'
    | '/analytics/phone'
    | '/analytics/practice'
    | '/analytics/reviews'
    | '/analytics/roi'
    | '/analytics/staff-performance'
    | '/bulk_/$subNav'
    | '/calls/call-history'
    | '/calls/call-queue-stats'
    | '/calls/team-presence'
    | '/calls/voicemails'
    | '/contacts/$filter'
    | '/contacts/lists'
    | '/fax/$filter'
    | '/forms/digitization'
    | '/forms/kiosk'
    | '/forms/library'
    | '/forms/submissions'
    | '/forms/templates'
    | '/home/dashboard'
    | '/home/onboarding'
    | '/home/partners'
    | '/messages/$filter'
    | '/nr-auth-test/$id'
    | '/onboarding/form'
    | '/payments/invoices'
    | '/payments/payment-plans'
    | '/payments/payouts'
    | '/payments/refunds'
    | '/reviews/$site'
    | '/schedule/availability'
    | '/schedule/calendar'
    | '/schedule/debug'
    | '/schedule/eligibility-list'
    | '/schedule/quickfill-history'
    | '/schedule/request-history'
    | '/schedule/schedule-activity'
    | '/test/$id'
    | '/test_/error'
    | '/weave-admin/roles'
    | '/x_/parent'
    | '/analytics/'
    | '/bulk_/'
    | '/calls/'
    | '/_public/nr-public-test/$id'
    | '/_public/onboarding-demo/form'
    | '/_public/portal/login'
    | '/_public/quotes_/$quoteId'
    | '/_public/reset-password_/$nonceToken'
    | '/_public/sign-in_/callback'
    | '/analytics/call-intelligence/$id'
    | '/analytics/call-intelligence/main'
    | '/analytics/marketing-attribution/main'
    | '/analytics/phone/call-duration'
    | '/analytics/phone/call-volume'
    | '/analytics/phone/main'
    | '/analytics/phone/phone-tree-call-volume-all'
    | '/analytics/practice/cancelled-appointments'
    | '/analytics/practice/demographics'
    | '/analytics/practice/hygiene-follow-up'
    | '/analytics/practice/hygiene-treatment'
    | '/analytics/practice/main'
    | '/analytics/practice/new-patients'
    | '/analytics/practice/practitioner-analysis'
    | '/analytics/practice/recaptured-patients'
    | '/analytics/practice/restorative-treatment'
    | '/analytics/practice/unscheduled-patients'
    | '/analytics/roi/appointment-reminders'
    | '/analytics/roi/bulk-text'
    | '/analytics/roi/missed-call-text-conversion'
    | '/analytics/roi/no-show-rate'
    | '/bulk_/$subNav_/$type'
    | '/fax/$filter/$faxId'
    | '/fax/drafts/$draftId'
    | '/fax/drafts/new'
    | '/fax/drafts/new-from-template'
    | '/fax/drafts/template-editor'
    | '/forms/builder_/$id'
    | '/forms/kiosk/patient-kiosk'
    | '/forms/library/forms'
    | '/forms/library/packets'
    | '/forms/submissions/archived'
    | '/forms/submissions/inbox'
    | '/forms/submissions/sent'
    | '/messages/$filter/new'
    | '/payments/invoices_/$id'
    | '/payments/payment-plans_/$planId'
    | '/payments/payment-plans_/create'
    | '/payments/payouts_/$payoutId'
    | '/payments/refunds_/$invoiceId'
    | '/reviews/$site/$reviewId'
    | '/x_/parent/child'
    | '/x_/redirect_/1'
    | '/x_/redirect_/2'
    | '/_public/it-partner-quotes_/$quoteId_/pdf'
    | '/_public/porting_/loa_/$loaId'
    | '/_public/quotes_/$quoteId_/pdf'
    | '/_public/test_/redirect_/1'
    | '/_public/test_/redirect_/2'
    | '/analytics/call-intelligence/follow-ups_/$type'
    | '/analytics/call-intelligence/service-issue_/$type'
    | '/analytics/marketing-attribution/campaign_/$number'
    | '/bulk_/$subNav_/$type_/$id'
    | '/fax/drafts/$draftId/begin'
    | '/fax/drafts/$draftId/choose-template'
    | '/fax/drafts/$draftId/cover'
    | '/fax/drafts/$draftId/finalize'
    | '/fax/drafts/$draftId/upload'
    | '/forms/library/forms_/$id'
    | '/forms/library/packets_/$id'
    | '/forms/submissions/archived/$submissionId'
    | '/forms/submissions/inbox/all'
    | '/forms/submissions/inbox/completed'
    | '/forms/submissions/inbox/needs-review'
    | '/forms/submissions/inbox/retry-sync'
    | '/forms/submissions/inbox/reviewed'
    | '/forms/submissions/inbox/sync-manually'
    | '/forms/submissions/sent/$submissionId'
    | '/messages/$filter/$groupId_/$threadId'
    | '/onboarding/form/$locationId_/$section'
    | '/onboarding/form/$locationId_/complete'
    | '/onboarding/form/$locationId_/dashboard'
    | '/payments/payouts_/$payoutId_/$locationId'
    | '/_public/accept-invite_/$nonceToken_/location_/$locationId'
    | '/_public/onboarding-demo/form/$locationId_/$section'
    | '/_public/onboarding-demo/form/$locationId_/complete'
    | '/_public/onboarding-demo/form/$locationId_/dashboard'
    | '/_public/porting_/loa_/$loaId_/pdf'
    | '/_public/user-invite_/$nonceToken_/location_/$locationId'
    | '/bulk_/$subNav_/$type_/$id_/$view'
    | '/calls/voicemail-boxes/$mailboxId/messages/$messageId'
    | '/forms/submissions/inbox/all/$submissionId'
    | '/forms/submissions/inbox/completed/$submissionId'
    | '/forms/submissions/inbox/needs-review/$submissionId'
    | '/forms/submissions/inbox/retry-sync/$submissionId'
    | '/forms/submissions/inbox/reviewed/$submissionId'
    | '/forms/submissions/inbox/sync-manually/$submissionId'
    | '/_public/portal/accept-invite_/$nonceToken_/location_/$locationId'
    | '/_public/portal/user-invite_/$nonceToken_/location_/$locationId'
    | '/onboarding/form/$locationId_/$section_/$task_/$step'
    | '/_public/onboarding-demo/form/$locationId_/$section_/$task_/$step'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BridgelineRoute: typeof BridgelineRoute
  FormsRoute: typeof FormsRouteWithChildren
  OnboardRoute: typeof OnboardRoute
  OnboardingRoute: typeof OnboardingRouteWithChildren
  ParentRoute: typeof ParentRoute
  WeaveCopilotRoute: typeof WeaveCopilotRoute
  PublicFrontChannelLogoutRoute: typeof PublicFrontChannelLogoutRoute
  PublicHydraErrorRoute: typeof PublicHydraErrorRoute
  PublicItPartnerQuotesRoute: typeof PublicItPartnerQuotesRoute
  PublicLoginRoute: typeof PublicLoginRoute
  PublicOktaRedirectRoute: typeof PublicOktaRedirectRoute
  PublicOnboardingDemoRoute: typeof PublicOnboardingDemoRouteWithChildren
  PublicPasswordResetRoute: typeof PublicPasswordResetRoute
  PublicResetRoute: typeof PublicResetRoute
  PublicSignInRoute: typeof PublicSignInRoute
  AnalyticsAiReceptionistRoute: typeof AnalyticsAiReceptionistRoute
  AnalyticsAppointmentRoute: typeof AnalyticsAppointmentRoute
  AnalyticsAutoRecallRoute: typeof AnalyticsAutoRecallRoute
  AnalyticsCallIntelligenceRoute: typeof AnalyticsCallIntelligenceRouteWithChildren
  AnalyticsDashboardRoute: typeof AnalyticsDashboardRoute
  AnalyticsMarketingAttributionRoute: typeof AnalyticsMarketingAttributionRouteWithChildren
  AnalyticsMessagingRoute: typeof AnalyticsMessagingRoute
  AnalyticsPhoneRoute: typeof AnalyticsPhoneRouteWithChildren
  AnalyticsPracticeRoute: typeof AnalyticsPracticeRouteWithChildren
  AnalyticsReviewsRoute: typeof AnalyticsReviewsRoute
  AnalyticsRoiRoute: typeof AnalyticsRoiRouteWithChildren
  AnalyticsStaffPerformanceRoute: typeof AnalyticsStaffPerformanceRoute
  BulkSubNavRoute: typeof BulkSubNavRoute
  CallsCallHistoryRoute: typeof CallsCallHistoryRoute
  CallsCallQueueStatsRoute: typeof CallsCallQueueStatsRoute
  CallsTeamPresenceRoute: typeof CallsTeamPresenceRoute
  CallsVoicemailsRoute: typeof CallsVoicemailsRoute
  ContactsFilterRoute: typeof ContactsFilterRoute
  ContactsListsRoute: typeof ContactsListsRoute
  FaxFilterRoute: typeof FaxFilterRouteWithChildren
  HomeDashboardRoute: typeof HomeDashboardRoute
  HomeOnboardingRoute: typeof HomeOnboardingRoute
  HomePartnersRoute: typeof HomePartnersRoute
  MessagesFilterRoute: typeof MessagesFilterRouteWithChildren
  NrAuthTestIdRoute: typeof NrAuthTestIdRoute
  PaymentsInvoicesRoute: typeof PaymentsInvoicesRoute
  PaymentsPaymentPlansRoute: typeof PaymentsPaymentPlansRoute
  PaymentsPayoutsRoute: typeof PaymentsPayoutsRoute
  PaymentsRefundsRoute: typeof PaymentsRefundsRoute
  ReviewsSiteRoute: typeof ReviewsSiteRouteWithChildren
  ScheduleAvailabilityRoute: typeof ScheduleAvailabilityRoute
  ScheduleCalendarRoute: typeof ScheduleCalendarRoute
  ScheduleDebugRoute: typeof ScheduleDebugRoute
  ScheduleEligibilityListRoute: typeof ScheduleEligibilityListRoute
  ScheduleQuickfillHistoryRoute: typeof ScheduleQuickfillHistoryRoute
  ScheduleRequestHistoryRoute: typeof ScheduleRequestHistoryRoute
  ScheduleScheduleActivityRoute: typeof ScheduleScheduleActivityRoute
  TestIdRoute: typeof TestIdRoute
  TestErrorRoute: typeof TestErrorRoute
  WeaveAdminRolesRoute: typeof WeaveAdminRolesRoute
  XParentRoute: typeof XParentRouteWithChildren
  AnalyticsIndexRoute: typeof AnalyticsIndexRoute
  BulkIndexRoute: typeof BulkIndexRoute
  CallsIndexRoute: typeof CallsIndexRoute
  PublicNrPublicTestIdRoute: typeof PublicNrPublicTestIdRoute
  PublicPortalLoginRoute: typeof PublicPortalLoginRoute
  PublicQuotesQuoteIdRoute: typeof PublicQuotesQuoteIdRoute
  PublicResetPasswordNonceTokenRoute: typeof PublicResetPasswordNonceTokenRoute
  PublicSignInCallbackRoute: typeof PublicSignInCallbackRoute
  BulkSubNavTypeRoute: typeof BulkSubNavTypeRoute
  FaxDraftsDraftIdRoute: typeof FaxDraftsDraftIdRouteWithChildren
  FaxDraftsNewRoute: typeof FaxDraftsNewRoute
  FaxDraftsNewFromTemplateRoute: typeof FaxDraftsNewFromTemplateRoute
  FaxDraftsTemplateEditorRoute: typeof FaxDraftsTemplateEditorRoute
  PaymentsInvoicesIdRoute: typeof PaymentsInvoicesIdRoute
  PaymentsPaymentPlansPlanIdRoute: typeof PaymentsPaymentPlansPlanIdRoute
  PaymentsPaymentPlansCreateRoute: typeof PaymentsPaymentPlansCreateRoute
  PaymentsPayoutsPayoutIdRoute: typeof PaymentsPayoutsPayoutIdRoute
  PaymentsRefundsInvoiceIdRoute: typeof PaymentsRefundsInvoiceIdRoute
  XRedirect1Route: typeof XRedirect1Route
  XRedirect2Route: typeof XRedirect2Route
  PublicItPartnerQuotesQuoteIdPdfRoute: typeof PublicItPartnerQuotesQuoteIdPdfRoute
  PublicPortingLoaLoaIdRoute: typeof PublicPortingLoaLoaIdRoute
  PublicQuotesQuoteIdPdfRoute: typeof PublicQuotesQuoteIdPdfRoute
  PublicTestRedirect1Route: typeof PublicTestRedirect1Route
  PublicTestRedirect2Route: typeof PublicTestRedirect2Route
  BulkSubNavTypeIdRoute: typeof BulkSubNavTypeIdRoute
  PaymentsPayoutsPayoutIdLocationIdRoute: typeof PaymentsPayoutsPayoutIdLocationIdRoute
  PublicAcceptInviteNonceTokenLocationLocationIdRoute: typeof PublicAcceptInviteNonceTokenLocationLocationIdRoute
  PublicPortingLoaLoaIdPdfRoute: typeof PublicPortingLoaLoaIdPdfRoute
  PublicUserInviteNonceTokenLocationLocationIdRoute: typeof PublicUserInviteNonceTokenLocationLocationIdRoute
  BulkSubNavTypeIdViewRoute: typeof BulkSubNavTypeIdViewRoute
  CallsVoicemailBoxesMailboxIdMessagesMessageIdRoute: typeof CallsVoicemailBoxesMailboxIdMessagesMessageIdRoute
  PublicPortalAcceptInviteNonceTokenLocationLocationIdRoute: typeof PublicPortalAcceptInviteNonceTokenLocationLocationIdRoute
  PublicPortalUserInviteNonceTokenLocationLocationIdRoute: typeof PublicPortalUserInviteNonceTokenLocationLocationIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/weave-copilot': {
      id: '/weave-copilot'
      path: '/weave-copilot'
      fullPath: '/weave-copilot'
      preLoaderRoute: typeof WeaveCopilotRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parent': {
      id: '/parent'
      path: '/parent'
      fullPath: '/parent'
      preLoaderRoute: typeof ParentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboard': {
      id: '/onboard'
      path: '/onboard'
      fullPath: '/onboard'
      preLoaderRoute: typeof OnboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forms': {
      id: '/forms'
      path: '/forms'
      fullPath: '/forms'
      preLoaderRoute: typeof FormsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bridgeline': {
      id: '/bridgeline'
      path: '/bridgeline'
      fullPath: '/bridgeline'
      preLoaderRoute: typeof BridgelineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calls/': {
      id: '/calls/'
      path: '/calls'
      fullPath: '/calls'
      preLoaderRoute: typeof CallsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bulk_/': {
      id: '/bulk_/'
      path: '/bulk'
      fullPath: '/bulk'
      preLoaderRoute: typeof BulkIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/': {
      id: '/analytics/'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/x_/parent': {
      id: '/x_/parent'
      path: '/x/parent'
      fullPath: '/x/parent'
      preLoaderRoute: typeof XParentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/weave-admin/roles': {
      id: '/weave-admin/roles'
      path: '/weave-admin/roles'
      fullPath: '/weave-admin/roles'
      preLoaderRoute: typeof WeaveAdminRolesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test_/error': {
      id: '/test_/error'
      path: '/test/error'
      fullPath: '/test/error'
      preLoaderRoute: typeof TestErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test/$id': {
      id: '/test/$id'
      path: '/test/$id'
      fullPath: '/test/$id'
      preLoaderRoute: typeof TestIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/schedule/schedule-activity': {
      id: '/schedule/schedule-activity'
      path: '/schedule/schedule-activity'
      fullPath: '/schedule/schedule-activity'
      preLoaderRoute: typeof ScheduleScheduleActivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/schedule/request-history': {
      id: '/schedule/request-history'
      path: '/schedule/request-history'
      fullPath: '/schedule/request-history'
      preLoaderRoute: typeof ScheduleRequestHistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/schedule/quickfill-history': {
      id: '/schedule/quickfill-history'
      path: '/schedule/quickfill-history'
      fullPath: '/schedule/quickfill-history'
      preLoaderRoute: typeof ScheduleQuickfillHistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/schedule/eligibility-list': {
      id: '/schedule/eligibility-list'
      path: '/schedule/eligibility-list'
      fullPath: '/schedule/eligibility-list'
      preLoaderRoute: typeof ScheduleEligibilityListRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/schedule/debug': {
      id: '/schedule/debug'
      path: '/schedule/debug'
      fullPath: '/schedule/debug'
      preLoaderRoute: typeof ScheduleDebugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/schedule/calendar': {
      id: '/schedule/calendar'
      path: '/schedule/calendar'
      fullPath: '/schedule/calendar'
      preLoaderRoute: typeof ScheduleCalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/schedule/availability': {
      id: '/schedule/availability'
      path: '/schedule/availability'
      fullPath: '/schedule/availability'
      preLoaderRoute: typeof ScheduleAvailabilityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reviews/$site': {
      id: '/reviews/$site'
      path: '/reviews/$site'
      fullPath: '/reviews/$site'
      preLoaderRoute: typeof ReviewsSiteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/refunds': {
      id: '/payments/refunds'
      path: '/payments/refunds'
      fullPath: '/payments/refunds'
      preLoaderRoute: typeof PaymentsRefundsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/payouts': {
      id: '/payments/payouts'
      path: '/payments/payouts'
      fullPath: '/payments/payouts'
      preLoaderRoute: typeof PaymentsPayoutsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/payment-plans': {
      id: '/payments/payment-plans'
      path: '/payments/payment-plans'
      fullPath: '/payments/payment-plans'
      preLoaderRoute: typeof PaymentsPaymentPlansRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/invoices': {
      id: '/payments/invoices'
      path: '/payments/invoices'
      fullPath: '/payments/invoices'
      preLoaderRoute: typeof PaymentsInvoicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/form': {
      id: '/onboarding/form'
      path: '/form'
      fullPath: '/onboarding/form'
      preLoaderRoute: typeof OnboardingFormRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/nr-auth-test/$id': {
      id: '/nr-auth-test/$id'
      path: '/nr-auth-test/$id'
      fullPath: '/nr-auth-test/$id'
      preLoaderRoute: typeof NrAuthTestIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/messages/$filter': {
      id: '/messages/$filter'
      path: '/messages/$filter'
      fullPath: '/messages/$filter'
      preLoaderRoute: typeof MessagesFilterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home/partners': {
      id: '/home/partners'
      path: '/home/partners'
      fullPath: '/home/partners'
      preLoaderRoute: typeof HomePartnersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home/onboarding': {
      id: '/home/onboarding'
      path: '/home/onboarding'
      fullPath: '/home/onboarding'
      preLoaderRoute: typeof HomeOnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home/dashboard': {
      id: '/home/dashboard'
      path: '/home/dashboard'
      fullPath: '/home/dashboard'
      preLoaderRoute: typeof HomeDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forms/templates': {
      id: '/forms/templates'
      path: '/templates'
      fullPath: '/forms/templates'
      preLoaderRoute: typeof FormsTemplatesRouteImport
      parentRoute: typeof FormsRoute
    }
    '/forms/submissions': {
      id: '/forms/submissions'
      path: '/submissions'
      fullPath: '/forms/submissions'
      preLoaderRoute: typeof FormsSubmissionsRouteImport
      parentRoute: typeof FormsRoute
    }
    '/forms/library': {
      id: '/forms/library'
      path: '/library'
      fullPath: '/forms/library'
      preLoaderRoute: typeof FormsLibraryRouteImport
      parentRoute: typeof FormsRoute
    }
    '/forms/kiosk': {
      id: '/forms/kiosk'
      path: '/kiosk'
      fullPath: '/forms/kiosk'
      preLoaderRoute: typeof FormsKioskRouteImport
      parentRoute: typeof FormsRoute
    }
    '/forms/digitization': {
      id: '/forms/digitization'
      path: '/digitization'
      fullPath: '/forms/digitization'
      preLoaderRoute: typeof FormsDigitizationRouteImport
      parentRoute: typeof FormsRoute
    }
    '/fax/$filter': {
      id: '/fax/$filter'
      path: '/fax/$filter'
      fullPath: '/fax/$filter'
      preLoaderRoute: typeof FaxFilterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contacts/lists': {
      id: '/contacts/lists'
      path: '/contacts/lists'
      fullPath: '/contacts/lists'
      preLoaderRoute: typeof ContactsListsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contacts/$filter': {
      id: '/contacts/$filter'
      path: '/contacts/$filter'
      fullPath: '/contacts/$filter'
      preLoaderRoute: typeof ContactsFilterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calls/voicemails': {
      id: '/calls/voicemails'
      path: '/calls/voicemails'
      fullPath: '/calls/voicemails'
      preLoaderRoute: typeof CallsVoicemailsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calls/team-presence': {
      id: '/calls/team-presence'
      path: '/calls/team-presence'
      fullPath: '/calls/team-presence'
      preLoaderRoute: typeof CallsTeamPresenceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calls/call-queue-stats': {
      id: '/calls/call-queue-stats'
      path: '/calls/call-queue-stats'
      fullPath: '/calls/call-queue-stats'
      preLoaderRoute: typeof CallsCallQueueStatsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calls/call-history': {
      id: '/calls/call-history'
      path: '/calls/call-history'
      fullPath: '/calls/call-history'
      preLoaderRoute: typeof CallsCallHistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bulk_/$subNav': {
      id: '/bulk_/$subNav'
      path: '/bulk/$subNav'
      fullPath: '/bulk/$subNav'
      preLoaderRoute: typeof BulkSubNavRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/staff-performance': {
      id: '/analytics/staff-performance'
      path: '/analytics/staff-performance'
      fullPath: '/analytics/staff-performance'
      preLoaderRoute: typeof AnalyticsStaffPerformanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/roi': {
      id: '/analytics/roi'
      path: '/analytics/roi'
      fullPath: '/analytics/roi'
      preLoaderRoute: typeof AnalyticsRoiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/reviews': {
      id: '/analytics/reviews'
      path: '/analytics/reviews'
      fullPath: '/analytics/reviews'
      preLoaderRoute: typeof AnalyticsReviewsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/practice': {
      id: '/analytics/practice'
      path: '/analytics/practice'
      fullPath: '/analytics/practice'
      preLoaderRoute: typeof AnalyticsPracticeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/phone': {
      id: '/analytics/phone'
      path: '/analytics/phone'
      fullPath: '/analytics/phone'
      preLoaderRoute: typeof AnalyticsPhoneRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/messaging': {
      id: '/analytics/messaging'
      path: '/analytics/messaging'
      fullPath: '/analytics/messaging'
      preLoaderRoute: typeof AnalyticsMessagingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/marketing-attribution': {
      id: '/analytics/marketing-attribution'
      path: '/analytics/marketing-attribution'
      fullPath: '/analytics/marketing-attribution'
      preLoaderRoute: typeof AnalyticsMarketingAttributionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/dashboard': {
      id: '/analytics/dashboard'
      path: '/analytics/dashboard'
      fullPath: '/analytics/dashboard'
      preLoaderRoute: typeof AnalyticsDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/call-intelligence': {
      id: '/analytics/call-intelligence'
      path: '/analytics/call-intelligence'
      fullPath: '/analytics/call-intelligence'
      preLoaderRoute: typeof AnalyticsCallIntelligenceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/auto-recall': {
      id: '/analytics/auto-recall'
      path: '/analytics/auto-recall'
      fullPath: '/analytics/auto-recall'
      preLoaderRoute: typeof AnalyticsAutoRecallRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/appointment': {
      id: '/analytics/appointment'
      path: '/analytics/appointment'
      fullPath: '/analytics/appointment'
      preLoaderRoute: typeof AnalyticsAppointmentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/ai-receptionist': {
      id: '/analytics/ai-receptionist'
      path: '/analytics/ai-receptionist'
      fullPath: '/analytics/ai-receptionist'
      preLoaderRoute: typeof AnalyticsAiReceptionistRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/sign-in': {
      id: '/_public/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof PublicSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/reset': {
      id: '/_public/reset'
      path: '/reset'
      fullPath: '/reset'
      preLoaderRoute: typeof PublicResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/password-reset': {
      id: '/_public/password-reset'
      path: '/password-reset'
      fullPath: '/password-reset'
      preLoaderRoute: typeof PublicPasswordResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/onboarding-demo': {
      id: '/_public/onboarding-demo'
      path: '/onboarding-demo'
      fullPath: '/onboarding-demo'
      preLoaderRoute: typeof PublicOnboardingDemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/okta-redirect': {
      id: '/_public/okta-redirect'
      path: '/okta-redirect'
      fullPath: '/okta-redirect'
      preLoaderRoute: typeof PublicOktaRedirectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/it-partner-quotes': {
      id: '/_public/it-partner-quotes'
      path: '/it-partner-quotes'
      fullPath: '/it-partner-quotes'
      preLoaderRoute: typeof PublicItPartnerQuotesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/hydra-error': {
      id: '/_public/hydra-error'
      path: '/hydra-error'
      fullPath: '/hydra-error'
      preLoaderRoute: typeof PublicHydraErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/front-channel-logout': {
      id: '/_public/front-channel-logout'
      path: '/front-channel-logout'
      fullPath: '/front-channel-logout'
      preLoaderRoute: typeof PublicFrontChannelLogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/x_/redirect_/2': {
      id: '/x_/redirect_/2'
      path: '/x/redirect/2'
      fullPath: '/x/redirect/2'
      preLoaderRoute: typeof XRedirect2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/x_/redirect_/1': {
      id: '/x_/redirect_/1'
      path: '/x/redirect/1'
      fullPath: '/x/redirect/1'
      preLoaderRoute: typeof XRedirect1RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/x_/parent/child': {
      id: '/x_/parent/child'
      path: '/child'
      fullPath: '/x/parent/child'
      preLoaderRoute: typeof XParentChildRouteImport
      parentRoute: typeof XParentRoute
    }
    '/reviews/$site/$reviewId': {
      id: '/reviews/$site/$reviewId'
      path: '/$reviewId'
      fullPath: '/reviews/$site/$reviewId'
      preLoaderRoute: typeof ReviewsSiteReviewIdRouteImport
      parentRoute: typeof ReviewsSiteRoute
    }
    '/payments/refunds_/$invoiceId': {
      id: '/payments/refunds_/$invoiceId'
      path: '/payments/refunds/$invoiceId'
      fullPath: '/payments/refunds/$invoiceId'
      preLoaderRoute: typeof PaymentsRefundsInvoiceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/payouts_/$payoutId': {
      id: '/payments/payouts_/$payoutId'
      path: '/payments/payouts/$payoutId'
      fullPath: '/payments/payouts/$payoutId'
      preLoaderRoute: typeof PaymentsPayoutsPayoutIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/payment-plans_/create': {
      id: '/payments/payment-plans_/create'
      path: '/payments/payment-plans/create'
      fullPath: '/payments/payment-plans/create'
      preLoaderRoute: typeof PaymentsPaymentPlansCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/payment-plans_/$planId': {
      id: '/payments/payment-plans_/$planId'
      path: '/payments/payment-plans/$planId'
      fullPath: '/payments/payment-plans/$planId'
      preLoaderRoute: typeof PaymentsPaymentPlansPlanIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/invoices_/$id': {
      id: '/payments/invoices_/$id'
      path: '/payments/invoices/$id'
      fullPath: '/payments/invoices/$id'
      preLoaderRoute: typeof PaymentsInvoicesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/messages/$filter/new': {
      id: '/messages/$filter/new'
      path: '/new'
      fullPath: '/messages/$filter/new'
      preLoaderRoute: typeof MessagesFilterNewRouteImport
      parentRoute: typeof MessagesFilterRoute
    }
    '/forms/submissions/sent': {
      id: '/forms/submissions/sent'
      path: '/sent'
      fullPath: '/forms/submissions/sent'
      preLoaderRoute: typeof FormsSubmissionsSentRouteImport
      parentRoute: typeof FormsSubmissionsRoute
    }
    '/forms/submissions/inbox': {
      id: '/forms/submissions/inbox'
      path: '/inbox'
      fullPath: '/forms/submissions/inbox'
      preLoaderRoute: typeof FormsSubmissionsInboxRouteImport
      parentRoute: typeof FormsSubmissionsRoute
    }
    '/forms/submissions/archived': {
      id: '/forms/submissions/archived'
      path: '/archived'
      fullPath: '/forms/submissions/archived'
      preLoaderRoute: typeof FormsSubmissionsArchivedRouteImport
      parentRoute: typeof FormsSubmissionsRoute
    }
    '/forms/library/packets': {
      id: '/forms/library/packets'
      path: '/packets'
      fullPath: '/forms/library/packets'
      preLoaderRoute: typeof FormsLibraryPacketsRouteImport
      parentRoute: typeof FormsLibraryRoute
    }
    '/forms/library/forms': {
      id: '/forms/library/forms'
      path: '/forms'
      fullPath: '/forms/library/forms'
      preLoaderRoute: typeof FormsLibraryFormsRouteImport
      parentRoute: typeof FormsLibraryRoute
    }
    '/forms/kiosk/patient-kiosk': {
      id: '/forms/kiosk/patient-kiosk'
      path: '/patient-kiosk'
      fullPath: '/forms/kiosk/patient-kiosk'
      preLoaderRoute: typeof FormsKioskPatientKioskRouteImport
      parentRoute: typeof FormsKioskRoute
    }
    '/forms/builder_/$id': {
      id: '/forms/builder_/$id'
      path: '/builder/$id'
      fullPath: '/forms/builder/$id'
      preLoaderRoute: typeof FormsBuilderIdRouteImport
      parentRoute: typeof FormsRoute
    }
    '/fax/drafts/template-editor': {
      id: '/fax/drafts/template-editor'
      path: '/fax/drafts/template-editor'
      fullPath: '/fax/drafts/template-editor'
      preLoaderRoute: typeof FaxDraftsTemplateEditorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fax/drafts/new-from-template': {
      id: '/fax/drafts/new-from-template'
      path: '/fax/drafts/new-from-template'
      fullPath: '/fax/drafts/new-from-template'
      preLoaderRoute: typeof FaxDraftsNewFromTemplateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fax/drafts/new': {
      id: '/fax/drafts/new'
      path: '/fax/drafts/new'
      fullPath: '/fax/drafts/new'
      preLoaderRoute: typeof FaxDraftsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fax/drafts/$draftId': {
      id: '/fax/drafts/$draftId'
      path: '/fax/drafts/$draftId'
      fullPath: '/fax/drafts/$draftId'
      preLoaderRoute: typeof FaxDraftsDraftIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fax/$filter/$faxId': {
      id: '/fax/$filter/$faxId'
      path: '/$faxId'
      fullPath: '/fax/$filter/$faxId'
      preLoaderRoute: typeof FaxFilterFaxIdRouteImport
      parentRoute: typeof FaxFilterRoute
    }
    '/bulk_/$subNav_/$type': {
      id: '/bulk_/$subNav_/$type'
      path: '/bulk/$subNav/$type'
      fullPath: '/bulk/$subNav/$type'
      preLoaderRoute: typeof BulkSubNavTypeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/roi/no-show-rate': {
      id: '/analytics/roi/no-show-rate'
      path: '/no-show-rate'
      fullPath: '/analytics/roi/no-show-rate'
      preLoaderRoute: typeof AnalyticsRoiNoShowRateRouteImport
      parentRoute: typeof AnalyticsRoiRoute
    }
    '/analytics/roi/missed-call-text-conversion': {
      id: '/analytics/roi/missed-call-text-conversion'
      path: '/missed-call-text-conversion'
      fullPath: '/analytics/roi/missed-call-text-conversion'
      preLoaderRoute: typeof AnalyticsRoiMissedCallTextConversionRouteImport
      parentRoute: typeof AnalyticsRoiRoute
    }
    '/analytics/roi/bulk-text': {
      id: '/analytics/roi/bulk-text'
      path: '/bulk-text'
      fullPath: '/analytics/roi/bulk-text'
      preLoaderRoute: typeof AnalyticsRoiBulkTextRouteImport
      parentRoute: typeof AnalyticsRoiRoute
    }
    '/analytics/roi/appointment-reminders': {
      id: '/analytics/roi/appointment-reminders'
      path: '/appointment-reminders'
      fullPath: '/analytics/roi/appointment-reminders'
      preLoaderRoute: typeof AnalyticsRoiAppointmentRemindersRouteImport
      parentRoute: typeof AnalyticsRoiRoute
    }
    '/analytics/practice/unscheduled-patients': {
      id: '/analytics/practice/unscheduled-patients'
      path: '/unscheduled-patients'
      fullPath: '/analytics/practice/unscheduled-patients'
      preLoaderRoute: typeof AnalyticsPracticeUnscheduledPatientsRouteImport
      parentRoute: typeof AnalyticsPracticeRoute
    }
    '/analytics/practice/restorative-treatment': {
      id: '/analytics/practice/restorative-treatment'
      path: '/restorative-treatment'
      fullPath: '/analytics/practice/restorative-treatment'
      preLoaderRoute: typeof AnalyticsPracticeRestorativeTreatmentRouteImport
      parentRoute: typeof AnalyticsPracticeRoute
    }
    '/analytics/practice/recaptured-patients': {
      id: '/analytics/practice/recaptured-patients'
      path: '/recaptured-patients'
      fullPath: '/analytics/practice/recaptured-patients'
      preLoaderRoute: typeof AnalyticsPracticeRecapturedPatientsRouteImport
      parentRoute: typeof AnalyticsPracticeRoute
    }
    '/analytics/practice/practitioner-analysis': {
      id: '/analytics/practice/practitioner-analysis'
      path: '/practitioner-analysis'
      fullPath: '/analytics/practice/practitioner-analysis'
      preLoaderRoute: typeof AnalyticsPracticePractitionerAnalysisRouteImport
      parentRoute: typeof AnalyticsPracticeRoute
    }
    '/analytics/practice/new-patients': {
      id: '/analytics/practice/new-patients'
      path: '/new-patients'
      fullPath: '/analytics/practice/new-patients'
      preLoaderRoute: typeof AnalyticsPracticeNewPatientsRouteImport
      parentRoute: typeof AnalyticsPracticeRoute
    }
    '/analytics/practice/main': {
      id: '/analytics/practice/main'
      path: '/main'
      fullPath: '/analytics/practice/main'
      preLoaderRoute: typeof AnalyticsPracticeMainRouteImport
      parentRoute: typeof AnalyticsPracticeRoute
    }
    '/analytics/practice/hygiene-treatment': {
      id: '/analytics/practice/hygiene-treatment'
      path: '/hygiene-treatment'
      fullPath: '/analytics/practice/hygiene-treatment'
      preLoaderRoute: typeof AnalyticsPracticeHygieneTreatmentRouteImport
      parentRoute: typeof AnalyticsPracticeRoute
    }
    '/analytics/practice/hygiene-follow-up': {
      id: '/analytics/practice/hygiene-follow-up'
      path: '/hygiene-follow-up'
      fullPath: '/analytics/practice/hygiene-follow-up'
      preLoaderRoute: typeof AnalyticsPracticeHygieneFollowUpRouteImport
      parentRoute: typeof AnalyticsPracticeRoute
    }
    '/analytics/practice/demographics': {
      id: '/analytics/practice/demographics'
      path: '/demographics'
      fullPath: '/analytics/practice/demographics'
      preLoaderRoute: typeof AnalyticsPracticeDemographicsRouteImport
      parentRoute: typeof AnalyticsPracticeRoute
    }
    '/analytics/practice/cancelled-appointments': {
      id: '/analytics/practice/cancelled-appointments'
      path: '/cancelled-appointments'
      fullPath: '/analytics/practice/cancelled-appointments'
      preLoaderRoute: typeof AnalyticsPracticeCancelledAppointmentsRouteImport
      parentRoute: typeof AnalyticsPracticeRoute
    }
    '/analytics/phone/phone-tree-call-volume-all': {
      id: '/analytics/phone/phone-tree-call-volume-all'
      path: '/phone-tree-call-volume-all'
      fullPath: '/analytics/phone/phone-tree-call-volume-all'
      preLoaderRoute: typeof AnalyticsPhonePhoneTreeCallVolumeAllRouteImport
      parentRoute: typeof AnalyticsPhoneRoute
    }
    '/analytics/phone/main': {
      id: '/analytics/phone/main'
      path: '/main'
      fullPath: '/analytics/phone/main'
      preLoaderRoute: typeof AnalyticsPhoneMainRouteImport
      parentRoute: typeof AnalyticsPhoneRoute
    }
    '/analytics/phone/call-volume': {
      id: '/analytics/phone/call-volume'
      path: '/call-volume'
      fullPath: '/analytics/phone/call-volume'
      preLoaderRoute: typeof AnalyticsPhoneCallVolumeRouteImport
      parentRoute: typeof AnalyticsPhoneRoute
    }
    '/analytics/phone/call-duration': {
      id: '/analytics/phone/call-duration'
      path: '/call-duration'
      fullPath: '/analytics/phone/call-duration'
      preLoaderRoute: typeof AnalyticsPhoneCallDurationRouteImport
      parentRoute: typeof AnalyticsPhoneRoute
    }
    '/analytics/marketing-attribution/main': {
      id: '/analytics/marketing-attribution/main'
      path: '/main'
      fullPath: '/analytics/marketing-attribution/main'
      preLoaderRoute: typeof AnalyticsMarketingAttributionMainRouteImport
      parentRoute: typeof AnalyticsMarketingAttributionRoute
    }
    '/analytics/call-intelligence/main': {
      id: '/analytics/call-intelligence/main'
      path: '/main'
      fullPath: '/analytics/call-intelligence/main'
      preLoaderRoute: typeof AnalyticsCallIntelligenceMainRouteImport
      parentRoute: typeof AnalyticsCallIntelligenceRoute
    }
    '/analytics/call-intelligence/$id': {
      id: '/analytics/call-intelligence/$id'
      path: '/$id'
      fullPath: '/analytics/call-intelligence/$id'
      preLoaderRoute: typeof AnalyticsCallIntelligenceIdRouteImport
      parentRoute: typeof AnalyticsCallIntelligenceRoute
    }
    '/_public/sign-in_/callback': {
      id: '/_public/sign-in_/callback'
      path: '/sign-in/callback'
      fullPath: '/sign-in/callback'
      preLoaderRoute: typeof PublicSignInCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/reset-password_/$nonceToken': {
      id: '/_public/reset-password_/$nonceToken'
      path: '/reset-password/$nonceToken'
      fullPath: '/reset-password/$nonceToken'
      preLoaderRoute: typeof PublicResetPasswordNonceTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/quotes_/$quoteId': {
      id: '/_public/quotes_/$quoteId'
      path: '/quotes/$quoteId'
      fullPath: '/quotes/$quoteId'
      preLoaderRoute: typeof PublicQuotesQuoteIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/portal/login': {
      id: '/_public/portal/login'
      path: '/portal/login'
      fullPath: '/portal/login'
      preLoaderRoute: typeof PublicPortalLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/onboarding-demo/form': {
      id: '/_public/onboarding-demo/form'
      path: '/form'
      fullPath: '/onboarding-demo/form'
      preLoaderRoute: typeof PublicOnboardingDemoFormRouteImport
      parentRoute: typeof PublicOnboardingDemoRoute
    }
    '/_public/nr-public-test/$id': {
      id: '/_public/nr-public-test/$id'
      path: '/nr-public-test/$id'
      fullPath: '/nr-public-test/$id'
      preLoaderRoute: typeof PublicNrPublicTestIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/payouts_/$payoutId_/$locationId': {
      id: '/payments/payouts_/$payoutId_/$locationId'
      path: '/payments/payouts/$payoutId/$locationId'
      fullPath: '/payments/payouts/$payoutId/$locationId'
      preLoaderRoute: typeof PaymentsPayoutsPayoutIdLocationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/form/$locationId_/dashboard': {
      id: '/onboarding/form/$locationId_/dashboard'
      path: '/$locationId/dashboard'
      fullPath: '/onboarding/form/$locationId/dashboard'
      preLoaderRoute: typeof OnboardingFormLocationIdDashboardRouteImport
      parentRoute: typeof OnboardingFormRoute
    }
    '/onboarding/form/$locationId_/complete': {
      id: '/onboarding/form/$locationId_/complete'
      path: '/$locationId/complete'
      fullPath: '/onboarding/form/$locationId/complete'
      preLoaderRoute: typeof OnboardingFormLocationIdCompleteRouteImport
      parentRoute: typeof OnboardingFormRoute
    }
    '/onboarding/form/$locationId_/$section': {
      id: '/onboarding/form/$locationId_/$section'
      path: '/$locationId/$section'
      fullPath: '/onboarding/form/$locationId/$section'
      preLoaderRoute: typeof OnboardingFormLocationIdSectionRouteImport
      parentRoute: typeof OnboardingFormRoute
    }
    '/messages/$filter/$groupId_/$threadId': {
      id: '/messages/$filter/$groupId_/$threadId'
      path: '/$groupId/$threadId'
      fullPath: '/messages/$filter/$groupId/$threadId'
      preLoaderRoute: typeof MessagesFilterGroupIdThreadIdRouteImport
      parentRoute: typeof MessagesFilterRoute
    }
    '/forms/submissions/sent/$submissionId': {
      id: '/forms/submissions/sent/$submissionId'
      path: '/$submissionId'
      fullPath: '/forms/submissions/sent/$submissionId'
      preLoaderRoute: typeof FormsSubmissionsSentSubmissionIdRouteImport
      parentRoute: typeof FormsSubmissionsSentRoute
    }
    '/forms/submissions/inbox/sync-manually': {
      id: '/forms/submissions/inbox/sync-manually'
      path: '/sync-manually'
      fullPath: '/forms/submissions/inbox/sync-manually'
      preLoaderRoute: typeof FormsSubmissionsInboxSyncManuallyRouteImport
      parentRoute: typeof FormsSubmissionsInboxRoute
    }
    '/forms/submissions/inbox/reviewed': {
      id: '/forms/submissions/inbox/reviewed'
      path: '/reviewed'
      fullPath: '/forms/submissions/inbox/reviewed'
      preLoaderRoute: typeof FormsSubmissionsInboxReviewedRouteImport
      parentRoute: typeof FormsSubmissionsInboxRoute
    }
    '/forms/submissions/inbox/retry-sync': {
      id: '/forms/submissions/inbox/retry-sync'
      path: '/retry-sync'
      fullPath: '/forms/submissions/inbox/retry-sync'
      preLoaderRoute: typeof FormsSubmissionsInboxRetrySyncRouteImport
      parentRoute: typeof FormsSubmissionsInboxRoute
    }
    '/forms/submissions/inbox/needs-review': {
      id: '/forms/submissions/inbox/needs-review'
      path: '/needs-review'
      fullPath: '/forms/submissions/inbox/needs-review'
      preLoaderRoute: typeof FormsSubmissionsInboxNeedsReviewRouteImport
      parentRoute: typeof FormsSubmissionsInboxRoute
    }
    '/forms/submissions/inbox/completed': {
      id: '/forms/submissions/inbox/completed'
      path: '/completed'
      fullPath: '/forms/submissions/inbox/completed'
      preLoaderRoute: typeof FormsSubmissionsInboxCompletedRouteImport
      parentRoute: typeof FormsSubmissionsInboxRoute
    }
    '/forms/submissions/inbox/all': {
      id: '/forms/submissions/inbox/all'
      path: '/all'
      fullPath: '/forms/submissions/inbox/all'
      preLoaderRoute: typeof FormsSubmissionsInboxAllRouteImport
      parentRoute: typeof FormsSubmissionsInboxRoute
    }
    '/forms/submissions/archived/$submissionId': {
      id: '/forms/submissions/archived/$submissionId'
      path: '/$submissionId'
      fullPath: '/forms/submissions/archived/$submissionId'
      preLoaderRoute: typeof FormsSubmissionsArchivedSubmissionIdRouteImport
      parentRoute: typeof FormsSubmissionsArchivedRoute
    }
    '/forms/library/packets_/$id': {
      id: '/forms/library/packets_/$id'
      path: '/packets/$id'
      fullPath: '/forms/library/packets/$id'
      preLoaderRoute: typeof FormsLibraryPacketsIdRouteImport
      parentRoute: typeof FormsLibraryRoute
    }
    '/forms/library/forms_/$id': {
      id: '/forms/library/forms_/$id'
      path: '/forms/$id'
      fullPath: '/forms/library/forms/$id'
      preLoaderRoute: typeof FormsLibraryFormsIdRouteImport
      parentRoute: typeof FormsLibraryRoute
    }
    '/fax/drafts/$draftId/upload': {
      id: '/fax/drafts/$draftId/upload'
      path: '/upload'
      fullPath: '/fax/drafts/$draftId/upload'
      preLoaderRoute: typeof FaxDraftsDraftIdUploadRouteImport
      parentRoute: typeof FaxDraftsDraftIdRoute
    }
    '/fax/drafts/$draftId/finalize': {
      id: '/fax/drafts/$draftId/finalize'
      path: '/finalize'
      fullPath: '/fax/drafts/$draftId/finalize'
      preLoaderRoute: typeof FaxDraftsDraftIdFinalizeRouteImport
      parentRoute: typeof FaxDraftsDraftIdRoute
    }
    '/fax/drafts/$draftId/cover': {
      id: '/fax/drafts/$draftId/cover'
      path: '/cover'
      fullPath: '/fax/drafts/$draftId/cover'
      preLoaderRoute: typeof FaxDraftsDraftIdCoverRouteImport
      parentRoute: typeof FaxDraftsDraftIdRoute
    }
    '/fax/drafts/$draftId/choose-template': {
      id: '/fax/drafts/$draftId/choose-template'
      path: '/choose-template'
      fullPath: '/fax/drafts/$draftId/choose-template'
      preLoaderRoute: typeof FaxDraftsDraftIdChooseTemplateRouteImport
      parentRoute: typeof FaxDraftsDraftIdRoute
    }
    '/fax/drafts/$draftId/begin': {
      id: '/fax/drafts/$draftId/begin'
      path: '/begin'
      fullPath: '/fax/drafts/$draftId/begin'
      preLoaderRoute: typeof FaxDraftsDraftIdBeginRouteImport
      parentRoute: typeof FaxDraftsDraftIdRoute
    }
    '/bulk_/$subNav_/$type_/$id': {
      id: '/bulk_/$subNav_/$type_/$id'
      path: '/bulk/$subNav/$type/$id'
      fullPath: '/bulk/$subNav/$type/$id'
      preLoaderRoute: typeof BulkSubNavTypeIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/marketing-attribution/campaign_/$number': {
      id: '/analytics/marketing-attribution/campaign_/$number'
      path: '/campaign/$number'
      fullPath: '/analytics/marketing-attribution/campaign/$number'
      preLoaderRoute: typeof AnalyticsMarketingAttributionCampaignNumberRouteImport
      parentRoute: typeof AnalyticsMarketingAttributionRoute
    }
    '/analytics/call-intelligence/service-issue_/$type': {
      id: '/analytics/call-intelligence/service-issue_/$type'
      path: '/service-issue/$type'
      fullPath: '/analytics/call-intelligence/service-issue/$type'
      preLoaderRoute: typeof AnalyticsCallIntelligenceServiceIssueTypeRouteImport
      parentRoute: typeof AnalyticsCallIntelligenceRoute
    }
    '/analytics/call-intelligence/follow-ups_/$type': {
      id: '/analytics/call-intelligence/follow-ups_/$type'
      path: '/follow-ups/$type'
      fullPath: '/analytics/call-intelligence/follow-ups/$type'
      preLoaderRoute: typeof AnalyticsCallIntelligenceFollowUpsTypeRouteImport
      parentRoute: typeof AnalyticsCallIntelligenceRoute
    }
    '/_public/test_/redirect_/2': {
      id: '/_public/test_/redirect_/2'
      path: '/test/redirect/2'
      fullPath: '/test/redirect/2'
      preLoaderRoute: typeof PublicTestRedirect2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/test_/redirect_/1': {
      id: '/_public/test_/redirect_/1'
      path: '/test/redirect/1'
      fullPath: '/test/redirect/1'
      preLoaderRoute: typeof PublicTestRedirect1RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/quotes_/$quoteId_/pdf': {
      id: '/_public/quotes_/$quoteId_/pdf'
      path: '/quotes/$quoteId/pdf'
      fullPath: '/quotes/$quoteId/pdf'
      preLoaderRoute: typeof PublicQuotesQuoteIdPdfRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/porting_/loa_/$loaId': {
      id: '/_public/porting_/loa_/$loaId'
      path: '/porting/loa/$loaId'
      fullPath: '/porting/loa/$loaId'
      preLoaderRoute: typeof PublicPortingLoaLoaIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/it-partner-quotes_/$quoteId_/pdf': {
      id: '/_public/it-partner-quotes_/$quoteId_/pdf'
      path: '/it-partner-quotes/$quoteId/pdf'
      fullPath: '/it-partner-quotes/$quoteId/pdf'
      preLoaderRoute: typeof PublicItPartnerQuotesQuoteIdPdfRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forms/submissions/inbox/sync-manually/$submissionId': {
      id: '/forms/submissions/inbox/sync-manually/$submissionId'
      path: '/$submissionId'
      fullPath: '/forms/submissions/inbox/sync-manually/$submissionId'
      preLoaderRoute: typeof FormsSubmissionsInboxSyncManuallySubmissionIdRouteImport
      parentRoute: typeof FormsSubmissionsInboxSyncManuallyRoute
    }
    '/forms/submissions/inbox/reviewed/$submissionId': {
      id: '/forms/submissions/inbox/reviewed/$submissionId'
      path: '/$submissionId'
      fullPath: '/forms/submissions/inbox/reviewed/$submissionId'
      preLoaderRoute: typeof FormsSubmissionsInboxReviewedSubmissionIdRouteImport
      parentRoute: typeof FormsSubmissionsInboxReviewedRoute
    }
    '/forms/submissions/inbox/retry-sync/$submissionId': {
      id: '/forms/submissions/inbox/retry-sync/$submissionId'
      path: '/$submissionId'
      fullPath: '/forms/submissions/inbox/retry-sync/$submissionId'
      preLoaderRoute: typeof FormsSubmissionsInboxRetrySyncSubmissionIdRouteImport
      parentRoute: typeof FormsSubmissionsInboxRetrySyncRoute
    }
    '/forms/submissions/inbox/needs-review/$submissionId': {
      id: '/forms/submissions/inbox/needs-review/$submissionId'
      path: '/$submissionId'
      fullPath: '/forms/submissions/inbox/needs-review/$submissionId'
      preLoaderRoute: typeof FormsSubmissionsInboxNeedsReviewSubmissionIdRouteImport
      parentRoute: typeof FormsSubmissionsInboxNeedsReviewRoute
    }
    '/forms/submissions/inbox/completed/$submissionId': {
      id: '/forms/submissions/inbox/completed/$submissionId'
      path: '/$submissionId'
      fullPath: '/forms/submissions/inbox/completed/$submissionId'
      preLoaderRoute: typeof FormsSubmissionsInboxCompletedSubmissionIdRouteImport
      parentRoute: typeof FormsSubmissionsInboxCompletedRoute
    }
    '/forms/submissions/inbox/all/$submissionId': {
      id: '/forms/submissions/inbox/all/$submissionId'
      path: '/$submissionId'
      fullPath: '/forms/submissions/inbox/all/$submissionId'
      preLoaderRoute: typeof FormsSubmissionsInboxAllSubmissionIdRouteImport
      parentRoute: typeof FormsSubmissionsInboxAllRoute
    }
    '/calls/voicemail-boxes/$mailboxId/messages/$messageId': {
      id: '/calls/voicemail-boxes/$mailboxId/messages/$messageId'
      path: '/calls/voicemail-boxes/$mailboxId/messages/$messageId'
      fullPath: '/calls/voicemail-boxes/$mailboxId/messages/$messageId'
      preLoaderRoute: typeof CallsVoicemailBoxesMailboxIdMessagesMessageIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bulk_/$subNav_/$type_/$id_/$view': {
      id: '/bulk_/$subNav_/$type_/$id_/$view'
      path: '/bulk/$subNav/$type/$id/$view'
      fullPath: '/bulk/$subNav/$type/$id/$view'
      preLoaderRoute: typeof BulkSubNavTypeIdViewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/user-invite_/$nonceToken_/location_/$locationId': {
      id: '/_public/user-invite_/$nonceToken_/location_/$locationId'
      path: '/user-invite/$nonceToken/location/$locationId'
      fullPath: '/user-invite/$nonceToken/location/$locationId'
      preLoaderRoute: typeof PublicUserInviteNonceTokenLocationLocationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/porting_/loa_/$loaId_/pdf': {
      id: '/_public/porting_/loa_/$loaId_/pdf'
      path: '/porting/loa/$loaId/pdf'
      fullPath: '/porting/loa/$loaId/pdf'
      preLoaderRoute: typeof PublicPortingLoaLoaIdPdfRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/onboarding-demo/form/$locationId_/dashboard': {
      id: '/_public/onboarding-demo/form/$locationId_/dashboard'
      path: '/$locationId/dashboard'
      fullPath: '/onboarding-demo/form/$locationId/dashboard'
      preLoaderRoute: typeof PublicOnboardingDemoFormLocationIdDashboardRouteImport
      parentRoute: typeof PublicOnboardingDemoFormRoute
    }
    '/_public/onboarding-demo/form/$locationId_/complete': {
      id: '/_public/onboarding-demo/form/$locationId_/complete'
      path: '/$locationId/complete'
      fullPath: '/onboarding-demo/form/$locationId/complete'
      preLoaderRoute: typeof PublicOnboardingDemoFormLocationIdCompleteRouteImport
      parentRoute: typeof PublicOnboardingDemoFormRoute
    }
    '/_public/onboarding-demo/form/$locationId_/$section': {
      id: '/_public/onboarding-demo/form/$locationId_/$section'
      path: '/$locationId/$section'
      fullPath: '/onboarding-demo/form/$locationId/$section'
      preLoaderRoute: typeof PublicOnboardingDemoFormLocationIdSectionRouteImport
      parentRoute: typeof PublicOnboardingDemoFormRoute
    }
    '/_public/accept-invite_/$nonceToken_/location_/$locationId': {
      id: '/_public/accept-invite_/$nonceToken_/location_/$locationId'
      path: '/accept-invite/$nonceToken/location/$locationId'
      fullPath: '/accept-invite/$nonceToken/location/$locationId'
      preLoaderRoute: typeof PublicAcceptInviteNonceTokenLocationLocationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/form/$locationId_/$section_/$task_/$step': {
      id: '/onboarding/form/$locationId_/$section_/$task_/$step'
      path: '/$locationId/$section/$task/$step'
      fullPath: '/onboarding/form/$locationId/$section/$task/$step'
      preLoaderRoute: typeof OnboardingFormLocationIdSectionTaskStepRouteImport
      parentRoute: typeof OnboardingFormRoute
    }
    '/_public/portal/user-invite_/$nonceToken_/location_/$locationId': {
      id: '/_public/portal/user-invite_/$nonceToken_/location_/$locationId'
      path: '/portal/user-invite/$nonceToken/location/$locationId'
      fullPath: '/portal/user-invite/$nonceToken/location/$locationId'
      preLoaderRoute: typeof PublicPortalUserInviteNonceTokenLocationLocationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/portal/accept-invite_/$nonceToken_/location_/$locationId': {
      id: '/_public/portal/accept-invite_/$nonceToken_/location_/$locationId'
      path: '/portal/accept-invite/$nonceToken/location/$locationId'
      fullPath: '/portal/accept-invite/$nonceToken/location/$locationId'
      preLoaderRoute: typeof PublicPortalAcceptInviteNonceTokenLocationLocationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/onboarding-demo/form/$locationId_/$section_/$task_/$step': {
      id: '/_public/onboarding-demo/form/$locationId_/$section_/$task_/$step'
      path: '/$locationId/$section/$task/$step'
      fullPath: '/onboarding-demo/form/$locationId/$section/$task/$step'
      preLoaderRoute: typeof PublicOnboardingDemoFormLocationIdSectionTaskStepRouteImport
      parentRoute: typeof PublicOnboardingDemoFormRoute
    }
  }
}

interface FormsKioskRouteChildren {
  FormsKioskPatientKioskRoute: typeof FormsKioskPatientKioskRoute
}

const FormsKioskRouteChildren: FormsKioskRouteChildren = {
  FormsKioskPatientKioskRoute: FormsKioskPatientKioskRoute,
}

const FormsKioskRouteWithChildren = FormsKioskRoute._addFileChildren(
  FormsKioskRouteChildren,
)

interface FormsLibraryRouteChildren {
  FormsLibraryFormsRoute: typeof FormsLibraryFormsRoute
  FormsLibraryPacketsRoute: typeof FormsLibraryPacketsRoute
  FormsLibraryFormsIdRoute: typeof FormsLibraryFormsIdRoute
  FormsLibraryPacketsIdRoute: typeof FormsLibraryPacketsIdRoute
}

const FormsLibraryRouteChildren: FormsLibraryRouteChildren = {
  FormsLibraryFormsRoute: FormsLibraryFormsRoute,
  FormsLibraryPacketsRoute: FormsLibraryPacketsRoute,
  FormsLibraryFormsIdRoute: FormsLibraryFormsIdRoute,
  FormsLibraryPacketsIdRoute: FormsLibraryPacketsIdRoute,
}

const FormsLibraryRouteWithChildren = FormsLibraryRoute._addFileChildren(
  FormsLibraryRouteChildren,
)

interface FormsSubmissionsArchivedRouteChildren {
  FormsSubmissionsArchivedSubmissionIdRoute: typeof FormsSubmissionsArchivedSubmissionIdRoute
}

const FormsSubmissionsArchivedRouteChildren: FormsSubmissionsArchivedRouteChildren =
  {
    FormsSubmissionsArchivedSubmissionIdRoute:
      FormsSubmissionsArchivedSubmissionIdRoute,
  }

const FormsSubmissionsArchivedRouteWithChildren =
  FormsSubmissionsArchivedRoute._addFileChildren(
    FormsSubmissionsArchivedRouteChildren,
  )

interface FormsSubmissionsInboxAllRouteChildren {
  FormsSubmissionsInboxAllSubmissionIdRoute: typeof FormsSubmissionsInboxAllSubmissionIdRoute
}

const FormsSubmissionsInboxAllRouteChildren: FormsSubmissionsInboxAllRouteChildren =
  {
    FormsSubmissionsInboxAllSubmissionIdRoute:
      FormsSubmissionsInboxAllSubmissionIdRoute,
  }

const FormsSubmissionsInboxAllRouteWithChildren =
  FormsSubmissionsInboxAllRoute._addFileChildren(
    FormsSubmissionsInboxAllRouteChildren,
  )

interface FormsSubmissionsInboxCompletedRouteChildren {
  FormsSubmissionsInboxCompletedSubmissionIdRoute: typeof FormsSubmissionsInboxCompletedSubmissionIdRoute
}

const FormsSubmissionsInboxCompletedRouteChildren: FormsSubmissionsInboxCompletedRouteChildren =
  {
    FormsSubmissionsInboxCompletedSubmissionIdRoute:
      FormsSubmissionsInboxCompletedSubmissionIdRoute,
  }

const FormsSubmissionsInboxCompletedRouteWithChildren =
  FormsSubmissionsInboxCompletedRoute._addFileChildren(
    FormsSubmissionsInboxCompletedRouteChildren,
  )

interface FormsSubmissionsInboxNeedsReviewRouteChildren {
  FormsSubmissionsInboxNeedsReviewSubmissionIdRoute: typeof FormsSubmissionsInboxNeedsReviewSubmissionIdRoute
}

const FormsSubmissionsInboxNeedsReviewRouteChildren: FormsSubmissionsInboxNeedsReviewRouteChildren =
  {
    FormsSubmissionsInboxNeedsReviewSubmissionIdRoute:
      FormsSubmissionsInboxNeedsReviewSubmissionIdRoute,
  }

const FormsSubmissionsInboxNeedsReviewRouteWithChildren =
  FormsSubmissionsInboxNeedsReviewRoute._addFileChildren(
    FormsSubmissionsInboxNeedsReviewRouteChildren,
  )

interface FormsSubmissionsInboxRetrySyncRouteChildren {
  FormsSubmissionsInboxRetrySyncSubmissionIdRoute: typeof FormsSubmissionsInboxRetrySyncSubmissionIdRoute
}

const FormsSubmissionsInboxRetrySyncRouteChildren: FormsSubmissionsInboxRetrySyncRouteChildren =
  {
    FormsSubmissionsInboxRetrySyncSubmissionIdRoute:
      FormsSubmissionsInboxRetrySyncSubmissionIdRoute,
  }

const FormsSubmissionsInboxRetrySyncRouteWithChildren =
  FormsSubmissionsInboxRetrySyncRoute._addFileChildren(
    FormsSubmissionsInboxRetrySyncRouteChildren,
  )

interface FormsSubmissionsInboxReviewedRouteChildren {
  FormsSubmissionsInboxReviewedSubmissionIdRoute: typeof FormsSubmissionsInboxReviewedSubmissionIdRoute
}

const FormsSubmissionsInboxReviewedRouteChildren: FormsSubmissionsInboxReviewedRouteChildren =
  {
    FormsSubmissionsInboxReviewedSubmissionIdRoute:
      FormsSubmissionsInboxReviewedSubmissionIdRoute,
  }

const FormsSubmissionsInboxReviewedRouteWithChildren =
  FormsSubmissionsInboxReviewedRoute._addFileChildren(
    FormsSubmissionsInboxReviewedRouteChildren,
  )

interface FormsSubmissionsInboxSyncManuallyRouteChildren {
  FormsSubmissionsInboxSyncManuallySubmissionIdRoute: typeof FormsSubmissionsInboxSyncManuallySubmissionIdRoute
}

const FormsSubmissionsInboxSyncManuallyRouteChildren: FormsSubmissionsInboxSyncManuallyRouteChildren =
  {
    FormsSubmissionsInboxSyncManuallySubmissionIdRoute:
      FormsSubmissionsInboxSyncManuallySubmissionIdRoute,
  }

const FormsSubmissionsInboxSyncManuallyRouteWithChildren =
  FormsSubmissionsInboxSyncManuallyRoute._addFileChildren(
    FormsSubmissionsInboxSyncManuallyRouteChildren,
  )

interface FormsSubmissionsInboxRouteChildren {
  FormsSubmissionsInboxAllRoute: typeof FormsSubmissionsInboxAllRouteWithChildren
  FormsSubmissionsInboxCompletedRoute: typeof FormsSubmissionsInboxCompletedRouteWithChildren
  FormsSubmissionsInboxNeedsReviewRoute: typeof FormsSubmissionsInboxNeedsReviewRouteWithChildren
  FormsSubmissionsInboxRetrySyncRoute: typeof FormsSubmissionsInboxRetrySyncRouteWithChildren
  FormsSubmissionsInboxReviewedRoute: typeof FormsSubmissionsInboxReviewedRouteWithChildren
  FormsSubmissionsInboxSyncManuallyRoute: typeof FormsSubmissionsInboxSyncManuallyRouteWithChildren
}

const FormsSubmissionsInboxRouteChildren: FormsSubmissionsInboxRouteChildren = {
  FormsSubmissionsInboxAllRoute: FormsSubmissionsInboxAllRouteWithChildren,
  FormsSubmissionsInboxCompletedRoute:
    FormsSubmissionsInboxCompletedRouteWithChildren,
  FormsSubmissionsInboxNeedsReviewRoute:
    FormsSubmissionsInboxNeedsReviewRouteWithChildren,
  FormsSubmissionsInboxRetrySyncRoute:
    FormsSubmissionsInboxRetrySyncRouteWithChildren,
  FormsSubmissionsInboxReviewedRoute:
    FormsSubmissionsInboxReviewedRouteWithChildren,
  FormsSubmissionsInboxSyncManuallyRoute:
    FormsSubmissionsInboxSyncManuallyRouteWithChildren,
}

const FormsSubmissionsInboxRouteWithChildren =
  FormsSubmissionsInboxRoute._addFileChildren(
    FormsSubmissionsInboxRouteChildren,
  )

interface FormsSubmissionsSentRouteChildren {
  FormsSubmissionsSentSubmissionIdRoute: typeof FormsSubmissionsSentSubmissionIdRoute
}

const FormsSubmissionsSentRouteChildren: FormsSubmissionsSentRouteChildren = {
  FormsSubmissionsSentSubmissionIdRoute: FormsSubmissionsSentSubmissionIdRoute,
}

const FormsSubmissionsSentRouteWithChildren =
  FormsSubmissionsSentRoute._addFileChildren(FormsSubmissionsSentRouteChildren)

interface FormsSubmissionsRouteChildren {
  FormsSubmissionsArchivedRoute: typeof FormsSubmissionsArchivedRouteWithChildren
  FormsSubmissionsInboxRoute: typeof FormsSubmissionsInboxRouteWithChildren
  FormsSubmissionsSentRoute: typeof FormsSubmissionsSentRouteWithChildren
}

const FormsSubmissionsRouteChildren: FormsSubmissionsRouteChildren = {
  FormsSubmissionsArchivedRoute: FormsSubmissionsArchivedRouteWithChildren,
  FormsSubmissionsInboxRoute: FormsSubmissionsInboxRouteWithChildren,
  FormsSubmissionsSentRoute: FormsSubmissionsSentRouteWithChildren,
}

const FormsSubmissionsRouteWithChildren =
  FormsSubmissionsRoute._addFileChildren(FormsSubmissionsRouteChildren)

interface FormsRouteChildren {
  FormsDigitizationRoute: typeof FormsDigitizationRoute
  FormsKioskRoute: typeof FormsKioskRouteWithChildren
  FormsLibraryRoute: typeof FormsLibraryRouteWithChildren
  FormsSubmissionsRoute: typeof FormsSubmissionsRouteWithChildren
  FormsTemplatesRoute: typeof FormsTemplatesRoute
  FormsBuilderIdRoute: typeof FormsBuilderIdRoute
}

const FormsRouteChildren: FormsRouteChildren = {
  FormsDigitizationRoute: FormsDigitizationRoute,
  FormsKioskRoute: FormsKioskRouteWithChildren,
  FormsLibraryRoute: FormsLibraryRouteWithChildren,
  FormsSubmissionsRoute: FormsSubmissionsRouteWithChildren,
  FormsTemplatesRoute: FormsTemplatesRoute,
  FormsBuilderIdRoute: FormsBuilderIdRoute,
}

const FormsRouteWithChildren = FormsRoute._addFileChildren(FormsRouteChildren)

interface OnboardingFormRouteChildren {
  OnboardingFormLocationIdSectionRoute: typeof OnboardingFormLocationIdSectionRoute
  OnboardingFormLocationIdCompleteRoute: typeof OnboardingFormLocationIdCompleteRoute
  OnboardingFormLocationIdDashboardRoute: typeof OnboardingFormLocationIdDashboardRoute
  OnboardingFormLocationIdSectionTaskStepRoute: typeof OnboardingFormLocationIdSectionTaskStepRoute
}

const OnboardingFormRouteChildren: OnboardingFormRouteChildren = {
  OnboardingFormLocationIdSectionRoute: OnboardingFormLocationIdSectionRoute,
  OnboardingFormLocationIdCompleteRoute: OnboardingFormLocationIdCompleteRoute,
  OnboardingFormLocationIdDashboardRoute:
    OnboardingFormLocationIdDashboardRoute,
  OnboardingFormLocationIdSectionTaskStepRoute:
    OnboardingFormLocationIdSectionTaskStepRoute,
}

const OnboardingFormRouteWithChildren = OnboardingFormRoute._addFileChildren(
  OnboardingFormRouteChildren,
)

interface OnboardingRouteChildren {
  OnboardingFormRoute: typeof OnboardingFormRouteWithChildren
}

const OnboardingRouteChildren: OnboardingRouteChildren = {
  OnboardingFormRoute: OnboardingFormRouteWithChildren,
}

const OnboardingRouteWithChildren = OnboardingRoute._addFileChildren(
  OnboardingRouteChildren,
)

interface PublicOnboardingDemoFormRouteChildren {
  PublicOnboardingDemoFormLocationIdSectionRoute: typeof PublicOnboardingDemoFormLocationIdSectionRoute
  PublicOnboardingDemoFormLocationIdCompleteRoute: typeof PublicOnboardingDemoFormLocationIdCompleteRoute
  PublicOnboardingDemoFormLocationIdDashboardRoute: typeof PublicOnboardingDemoFormLocationIdDashboardRoute
  PublicOnboardingDemoFormLocationIdSectionTaskStepRoute: typeof PublicOnboardingDemoFormLocationIdSectionTaskStepRoute
}

const PublicOnboardingDemoFormRouteChildren: PublicOnboardingDemoFormRouteChildren =
  {
    PublicOnboardingDemoFormLocationIdSectionRoute:
      PublicOnboardingDemoFormLocationIdSectionRoute,
    PublicOnboardingDemoFormLocationIdCompleteRoute:
      PublicOnboardingDemoFormLocationIdCompleteRoute,
    PublicOnboardingDemoFormLocationIdDashboardRoute:
      PublicOnboardingDemoFormLocationIdDashboardRoute,
    PublicOnboardingDemoFormLocationIdSectionTaskStepRoute:
      PublicOnboardingDemoFormLocationIdSectionTaskStepRoute,
  }

const PublicOnboardingDemoFormRouteWithChildren =
  PublicOnboardingDemoFormRoute._addFileChildren(
    PublicOnboardingDemoFormRouteChildren,
  )

interface PublicOnboardingDemoRouteChildren {
  PublicOnboardingDemoFormRoute: typeof PublicOnboardingDemoFormRouteWithChildren
}

const PublicOnboardingDemoRouteChildren: PublicOnboardingDemoRouteChildren = {
  PublicOnboardingDemoFormRoute: PublicOnboardingDemoFormRouteWithChildren,
}

const PublicOnboardingDemoRouteWithChildren =
  PublicOnboardingDemoRoute._addFileChildren(PublicOnboardingDemoRouteChildren)

interface AnalyticsCallIntelligenceRouteChildren {
  AnalyticsCallIntelligenceIdRoute: typeof AnalyticsCallIntelligenceIdRoute
  AnalyticsCallIntelligenceMainRoute: typeof AnalyticsCallIntelligenceMainRoute
  AnalyticsCallIntelligenceFollowUpsTypeRoute: typeof AnalyticsCallIntelligenceFollowUpsTypeRoute
  AnalyticsCallIntelligenceServiceIssueTypeRoute: typeof AnalyticsCallIntelligenceServiceIssueTypeRoute
}

const AnalyticsCallIntelligenceRouteChildren: AnalyticsCallIntelligenceRouteChildren =
  {
    AnalyticsCallIntelligenceIdRoute: AnalyticsCallIntelligenceIdRoute,
    AnalyticsCallIntelligenceMainRoute: AnalyticsCallIntelligenceMainRoute,
    AnalyticsCallIntelligenceFollowUpsTypeRoute:
      AnalyticsCallIntelligenceFollowUpsTypeRoute,
    AnalyticsCallIntelligenceServiceIssueTypeRoute:
      AnalyticsCallIntelligenceServiceIssueTypeRoute,
  }

const AnalyticsCallIntelligenceRouteWithChildren =
  AnalyticsCallIntelligenceRoute._addFileChildren(
    AnalyticsCallIntelligenceRouteChildren,
  )

interface AnalyticsMarketingAttributionRouteChildren {
  AnalyticsMarketingAttributionMainRoute: typeof AnalyticsMarketingAttributionMainRoute
  AnalyticsMarketingAttributionCampaignNumberRoute: typeof AnalyticsMarketingAttributionCampaignNumberRoute
}

const AnalyticsMarketingAttributionRouteChildren: AnalyticsMarketingAttributionRouteChildren =
  {
    AnalyticsMarketingAttributionMainRoute:
      AnalyticsMarketingAttributionMainRoute,
    AnalyticsMarketingAttributionCampaignNumberRoute:
      AnalyticsMarketingAttributionCampaignNumberRoute,
  }

const AnalyticsMarketingAttributionRouteWithChildren =
  AnalyticsMarketingAttributionRoute._addFileChildren(
    AnalyticsMarketingAttributionRouteChildren,
  )

interface AnalyticsPhoneRouteChildren {
  AnalyticsPhoneCallDurationRoute: typeof AnalyticsPhoneCallDurationRoute
  AnalyticsPhoneCallVolumeRoute: typeof AnalyticsPhoneCallVolumeRoute
  AnalyticsPhoneMainRoute: typeof AnalyticsPhoneMainRoute
  AnalyticsPhonePhoneTreeCallVolumeAllRoute: typeof AnalyticsPhonePhoneTreeCallVolumeAllRoute
}

const AnalyticsPhoneRouteChildren: AnalyticsPhoneRouteChildren = {
  AnalyticsPhoneCallDurationRoute: AnalyticsPhoneCallDurationRoute,
  AnalyticsPhoneCallVolumeRoute: AnalyticsPhoneCallVolumeRoute,
  AnalyticsPhoneMainRoute: AnalyticsPhoneMainRoute,
  AnalyticsPhonePhoneTreeCallVolumeAllRoute:
    AnalyticsPhonePhoneTreeCallVolumeAllRoute,
}

const AnalyticsPhoneRouteWithChildren = AnalyticsPhoneRoute._addFileChildren(
  AnalyticsPhoneRouteChildren,
)

interface AnalyticsPracticeRouteChildren {
  AnalyticsPracticeCancelledAppointmentsRoute: typeof AnalyticsPracticeCancelledAppointmentsRoute
  AnalyticsPracticeDemographicsRoute: typeof AnalyticsPracticeDemographicsRoute
  AnalyticsPracticeHygieneFollowUpRoute: typeof AnalyticsPracticeHygieneFollowUpRoute
  AnalyticsPracticeHygieneTreatmentRoute: typeof AnalyticsPracticeHygieneTreatmentRoute
  AnalyticsPracticeMainRoute: typeof AnalyticsPracticeMainRoute
  AnalyticsPracticeNewPatientsRoute: typeof AnalyticsPracticeNewPatientsRoute
  AnalyticsPracticePractitionerAnalysisRoute: typeof AnalyticsPracticePractitionerAnalysisRoute
  AnalyticsPracticeRecapturedPatientsRoute: typeof AnalyticsPracticeRecapturedPatientsRoute
  AnalyticsPracticeRestorativeTreatmentRoute: typeof AnalyticsPracticeRestorativeTreatmentRoute
  AnalyticsPracticeUnscheduledPatientsRoute: typeof AnalyticsPracticeUnscheduledPatientsRoute
}

const AnalyticsPracticeRouteChildren: AnalyticsPracticeRouteChildren = {
  AnalyticsPracticeCancelledAppointmentsRoute:
    AnalyticsPracticeCancelledAppointmentsRoute,
  AnalyticsPracticeDemographicsRoute: AnalyticsPracticeDemographicsRoute,
  AnalyticsPracticeHygieneFollowUpRoute: AnalyticsPracticeHygieneFollowUpRoute,
  AnalyticsPracticeHygieneTreatmentRoute:
    AnalyticsPracticeHygieneTreatmentRoute,
  AnalyticsPracticeMainRoute: AnalyticsPracticeMainRoute,
  AnalyticsPracticeNewPatientsRoute: AnalyticsPracticeNewPatientsRoute,
  AnalyticsPracticePractitionerAnalysisRoute:
    AnalyticsPracticePractitionerAnalysisRoute,
  AnalyticsPracticeRecapturedPatientsRoute:
    AnalyticsPracticeRecapturedPatientsRoute,
  AnalyticsPracticeRestorativeTreatmentRoute:
    AnalyticsPracticeRestorativeTreatmentRoute,
  AnalyticsPracticeUnscheduledPatientsRoute:
    AnalyticsPracticeUnscheduledPatientsRoute,
}

const AnalyticsPracticeRouteWithChildren =
  AnalyticsPracticeRoute._addFileChildren(AnalyticsPracticeRouteChildren)

interface AnalyticsRoiRouteChildren {
  AnalyticsRoiAppointmentRemindersRoute: typeof AnalyticsRoiAppointmentRemindersRoute
  AnalyticsRoiBulkTextRoute: typeof AnalyticsRoiBulkTextRoute
  AnalyticsRoiMissedCallTextConversionRoute: typeof AnalyticsRoiMissedCallTextConversionRoute
  AnalyticsRoiNoShowRateRoute: typeof AnalyticsRoiNoShowRateRoute
}

const AnalyticsRoiRouteChildren: AnalyticsRoiRouteChildren = {
  AnalyticsRoiAppointmentRemindersRoute: AnalyticsRoiAppointmentRemindersRoute,
  AnalyticsRoiBulkTextRoute: AnalyticsRoiBulkTextRoute,
  AnalyticsRoiMissedCallTextConversionRoute:
    AnalyticsRoiMissedCallTextConversionRoute,
  AnalyticsRoiNoShowRateRoute: AnalyticsRoiNoShowRateRoute,
}

const AnalyticsRoiRouteWithChildren = AnalyticsRoiRoute._addFileChildren(
  AnalyticsRoiRouteChildren,
)

interface FaxFilterRouteChildren {
  FaxFilterFaxIdRoute: typeof FaxFilterFaxIdRoute
}

const FaxFilterRouteChildren: FaxFilterRouteChildren = {
  FaxFilterFaxIdRoute: FaxFilterFaxIdRoute,
}

const FaxFilterRouteWithChildren = FaxFilterRoute._addFileChildren(
  FaxFilterRouteChildren,
)

interface MessagesFilterRouteChildren {
  MessagesFilterNewRoute: typeof MessagesFilterNewRoute
  MessagesFilterGroupIdThreadIdRoute: typeof MessagesFilterGroupIdThreadIdRoute
}

const MessagesFilterRouteChildren: MessagesFilterRouteChildren = {
  MessagesFilterNewRoute: MessagesFilterNewRoute,
  MessagesFilterGroupIdThreadIdRoute: MessagesFilterGroupIdThreadIdRoute,
}

const MessagesFilterRouteWithChildren = MessagesFilterRoute._addFileChildren(
  MessagesFilterRouteChildren,
)

interface ReviewsSiteRouteChildren {
  ReviewsSiteReviewIdRoute: typeof ReviewsSiteReviewIdRoute
}

const ReviewsSiteRouteChildren: ReviewsSiteRouteChildren = {
  ReviewsSiteReviewIdRoute: ReviewsSiteReviewIdRoute,
}

const ReviewsSiteRouteWithChildren = ReviewsSiteRoute._addFileChildren(
  ReviewsSiteRouteChildren,
)

interface XParentRouteChildren {
  XParentChildRoute: typeof XParentChildRoute
}

const XParentRouteChildren: XParentRouteChildren = {
  XParentChildRoute: XParentChildRoute,
}

const XParentRouteWithChildren =
  XParentRoute._addFileChildren(XParentRouteChildren)

interface FaxDraftsDraftIdRouteChildren {
  FaxDraftsDraftIdBeginRoute: typeof FaxDraftsDraftIdBeginRoute
  FaxDraftsDraftIdChooseTemplateRoute: typeof FaxDraftsDraftIdChooseTemplateRoute
  FaxDraftsDraftIdCoverRoute: typeof FaxDraftsDraftIdCoverRoute
  FaxDraftsDraftIdFinalizeRoute: typeof FaxDraftsDraftIdFinalizeRoute
  FaxDraftsDraftIdUploadRoute: typeof FaxDraftsDraftIdUploadRoute
}

const FaxDraftsDraftIdRouteChildren: FaxDraftsDraftIdRouteChildren = {
  FaxDraftsDraftIdBeginRoute: FaxDraftsDraftIdBeginRoute,
  FaxDraftsDraftIdChooseTemplateRoute: FaxDraftsDraftIdChooseTemplateRoute,
  FaxDraftsDraftIdCoverRoute: FaxDraftsDraftIdCoverRoute,
  FaxDraftsDraftIdFinalizeRoute: FaxDraftsDraftIdFinalizeRoute,
  FaxDraftsDraftIdUploadRoute: FaxDraftsDraftIdUploadRoute,
}

const FaxDraftsDraftIdRouteWithChildren =
  FaxDraftsDraftIdRoute._addFileChildren(FaxDraftsDraftIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BridgelineRoute: BridgelineRoute,
  FormsRoute: FormsRouteWithChildren,
  OnboardRoute: OnboardRoute,
  OnboardingRoute: OnboardingRouteWithChildren,
  ParentRoute: ParentRoute,
  WeaveCopilotRoute: WeaveCopilotRoute,
  PublicFrontChannelLogoutRoute: PublicFrontChannelLogoutRoute,
  PublicHydraErrorRoute: PublicHydraErrorRoute,
  PublicItPartnerQuotesRoute: PublicItPartnerQuotesRoute,
  PublicLoginRoute: PublicLoginRoute,
  PublicOktaRedirectRoute: PublicOktaRedirectRoute,
  PublicOnboardingDemoRoute: PublicOnboardingDemoRouteWithChildren,
  PublicPasswordResetRoute: PublicPasswordResetRoute,
  PublicResetRoute: PublicResetRoute,
  PublicSignInRoute: PublicSignInRoute,
  AnalyticsAiReceptionistRoute: AnalyticsAiReceptionistRoute,
  AnalyticsAppointmentRoute: AnalyticsAppointmentRoute,
  AnalyticsAutoRecallRoute: AnalyticsAutoRecallRoute,
  AnalyticsCallIntelligenceRoute: AnalyticsCallIntelligenceRouteWithChildren,
  AnalyticsDashboardRoute: AnalyticsDashboardRoute,
  AnalyticsMarketingAttributionRoute:
    AnalyticsMarketingAttributionRouteWithChildren,
  AnalyticsMessagingRoute: AnalyticsMessagingRoute,
  AnalyticsPhoneRoute: AnalyticsPhoneRouteWithChildren,
  AnalyticsPracticeRoute: AnalyticsPracticeRouteWithChildren,
  AnalyticsReviewsRoute: AnalyticsReviewsRoute,
  AnalyticsRoiRoute: AnalyticsRoiRouteWithChildren,
  AnalyticsStaffPerformanceRoute: AnalyticsStaffPerformanceRoute,
  BulkSubNavRoute: BulkSubNavRoute,
  CallsCallHistoryRoute: CallsCallHistoryRoute,
  CallsCallQueueStatsRoute: CallsCallQueueStatsRoute,
  CallsTeamPresenceRoute: CallsTeamPresenceRoute,
  CallsVoicemailsRoute: CallsVoicemailsRoute,
  ContactsFilterRoute: ContactsFilterRoute,
  ContactsListsRoute: ContactsListsRoute,
  FaxFilterRoute: FaxFilterRouteWithChildren,
  HomeDashboardRoute: HomeDashboardRoute,
  HomeOnboardingRoute: HomeOnboardingRoute,
  HomePartnersRoute: HomePartnersRoute,
  MessagesFilterRoute: MessagesFilterRouteWithChildren,
  NrAuthTestIdRoute: NrAuthTestIdRoute,
  PaymentsInvoicesRoute: PaymentsInvoicesRoute,
  PaymentsPaymentPlansRoute: PaymentsPaymentPlansRoute,
  PaymentsPayoutsRoute: PaymentsPayoutsRoute,
  PaymentsRefundsRoute: PaymentsRefundsRoute,
  ReviewsSiteRoute: ReviewsSiteRouteWithChildren,
  ScheduleAvailabilityRoute: ScheduleAvailabilityRoute,
  ScheduleCalendarRoute: ScheduleCalendarRoute,
  ScheduleDebugRoute: ScheduleDebugRoute,
  ScheduleEligibilityListRoute: ScheduleEligibilityListRoute,
  ScheduleQuickfillHistoryRoute: ScheduleQuickfillHistoryRoute,
  ScheduleRequestHistoryRoute: ScheduleRequestHistoryRoute,
  ScheduleScheduleActivityRoute: ScheduleScheduleActivityRoute,
  TestIdRoute: TestIdRoute,
  TestErrorRoute: TestErrorRoute,
  WeaveAdminRolesRoute: WeaveAdminRolesRoute,
  XParentRoute: XParentRouteWithChildren,
  AnalyticsIndexRoute: AnalyticsIndexRoute,
  BulkIndexRoute: BulkIndexRoute,
  CallsIndexRoute: CallsIndexRoute,
  PublicNrPublicTestIdRoute: PublicNrPublicTestIdRoute,
  PublicPortalLoginRoute: PublicPortalLoginRoute,
  PublicQuotesQuoteIdRoute: PublicQuotesQuoteIdRoute,
  PublicResetPasswordNonceTokenRoute: PublicResetPasswordNonceTokenRoute,
  PublicSignInCallbackRoute: PublicSignInCallbackRoute,
  BulkSubNavTypeRoute: BulkSubNavTypeRoute,
  FaxDraftsDraftIdRoute: FaxDraftsDraftIdRouteWithChildren,
  FaxDraftsNewRoute: FaxDraftsNewRoute,
  FaxDraftsNewFromTemplateRoute: FaxDraftsNewFromTemplateRoute,
  FaxDraftsTemplateEditorRoute: FaxDraftsTemplateEditorRoute,
  PaymentsInvoicesIdRoute: PaymentsInvoicesIdRoute,
  PaymentsPaymentPlansPlanIdRoute: PaymentsPaymentPlansPlanIdRoute,
  PaymentsPaymentPlansCreateRoute: PaymentsPaymentPlansCreateRoute,
  PaymentsPayoutsPayoutIdRoute: PaymentsPayoutsPayoutIdRoute,
  PaymentsRefundsInvoiceIdRoute: PaymentsRefundsInvoiceIdRoute,
  XRedirect1Route: XRedirect1Route,
  XRedirect2Route: XRedirect2Route,
  PublicItPartnerQuotesQuoteIdPdfRoute: PublicItPartnerQuotesQuoteIdPdfRoute,
  PublicPortingLoaLoaIdRoute: PublicPortingLoaLoaIdRoute,
  PublicQuotesQuoteIdPdfRoute: PublicQuotesQuoteIdPdfRoute,
  PublicTestRedirect1Route: PublicTestRedirect1Route,
  PublicTestRedirect2Route: PublicTestRedirect2Route,
  BulkSubNavTypeIdRoute: BulkSubNavTypeIdRoute,
  PaymentsPayoutsPayoutIdLocationIdRoute:
    PaymentsPayoutsPayoutIdLocationIdRoute,
  PublicAcceptInviteNonceTokenLocationLocationIdRoute:
    PublicAcceptInviteNonceTokenLocationLocationIdRoute,
  PublicPortingLoaLoaIdPdfRoute: PublicPortingLoaLoaIdPdfRoute,
  PublicUserInviteNonceTokenLocationLocationIdRoute:
    PublicUserInviteNonceTokenLocationLocationIdRoute,
  BulkSubNavTypeIdViewRoute: BulkSubNavTypeIdViewRoute,
  CallsVoicemailBoxesMailboxIdMessagesMessageIdRoute:
    CallsVoicemailBoxesMailboxIdMessagesMessageIdRoute,
  PublicPortalAcceptInviteNonceTokenLocationLocationIdRoute:
    PublicPortalAcceptInviteNonceTokenLocationLocationIdRoute,
  PublicPortalUserInviteNonceTokenLocationLocationIdRoute:
    PublicPortalUserInviteNonceTokenLocationLocationIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

export type {
  FormsKioskRouteChildren,
  FormsLibraryRouteChildren,
  FormsSubmissionsArchivedRouteChildren,
  FormsSubmissionsInboxAllRouteChildren,
  FormsSubmissionsInboxCompletedRouteChildren,
  FormsSubmissionsInboxNeedsReviewRouteChildren,
  FormsSubmissionsInboxRetrySyncRouteChildren,
  FormsSubmissionsInboxReviewedRouteChildren,
  FormsSubmissionsInboxSyncManuallyRouteChildren,
  FormsSubmissionsInboxRouteChildren,
  FormsSubmissionsSentRouteChildren,
  FormsSubmissionsRouteChildren,
  FormsRouteChildren,
  OnboardingFormRouteChildren,
  OnboardingRouteChildren,
  PublicOnboardingDemoFormRouteChildren,
  PublicOnboardingDemoRouteChildren,
  AnalyticsCallIntelligenceRouteChildren,
  AnalyticsMarketingAttributionRouteChildren,
  AnalyticsPhoneRouteChildren,
  AnalyticsPracticeRouteChildren,
  AnalyticsRoiRouteChildren,
  FaxFilterRouteChildren,
  MessagesFilterRouteChildren,
  ReviewsSiteRouteChildren,
  XParentRouteChildren,
  FaxDraftsDraftIdRouteChildren,
}
